module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "title65"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SECTION 2 – NATIONAL REPORTS")])])]), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title65"
    }
  }), _c('a', {
    attrs: {
      "id": "title66"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("AUSTRIA")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("AUSTRIA – BASIC FACTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "43.48%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "56.52%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8.2 million")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence budget 2010:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 2.1 billion (US$2.5 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GDP 2009:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 280 billion (US$341 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land area:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("82,700 sq kms (32,380 sq miles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Capital:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Vienna (Population 1.5 million)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Life expectancy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("78 years")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population growth rate:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("0.4 per cent")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Total Armed Forces")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "44.40%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "55.60%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("14,000 (about 6,000 conscripts)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Navy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Austria has no navy")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Command:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2,500 (about 1,000 conscripts)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Support Command:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("11,000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Reserves:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Possibly 30,000 ready reserves")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MINISTRY OF DEFENCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contact Details")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Ministry of Defence")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Bundesministerium fur Landesverteidigung")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Dampfschiffstrasse 2")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("A-1030 Wien")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("AUSTRIA")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("AUSTRIAN ARMY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army Strength:")]), _vm._v(" approximately 8,000 professionals and 6,000 conscripts (total about 14,000)\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Military Commands (Joint Forces – Graz and Salzburg)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Jager Brigade (Infantry)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Panzer Grenadier Brigades (Mechanised Infantry)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Communications Groups")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army Commands")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Military Operations are controlled by Land Forces Command Headquarters in Vienna through the following headquarters:")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "70%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0031.jpg",
      "src": "images/e9781783032051_i0031.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Military Area Commands with a combined total of approximately 15 infantry battalions under command are as follows:\n")])]), _vm._v(" "), _c('ul', {
    staticClass: "bl"
  }, [_c('li', {
    staticClass: "bsl"
  }, [_vm._v("Vienna")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Burgenland")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Niederosterreich")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Oberosterreich")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Steinmark")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Tirol")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Karnten")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Salzburg")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Vorarlberg")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Note:")]), _vm._v(" The Vienna Military Command has 1 x Infantry Regiment assigned (1 x battalion in peace and 4 x battalions on mobilisation) plus 1 x Guards Battalion.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Jager Brigade Outline Organisation (Mechanised)")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "66%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0032.jpg",
      "src": "images/e9781783032051_i0032.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Panzer Grenadier Brigade Outline Organisation (Armoured)")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "66%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0033.jpg",
      "src": "images/e9781783032051_i0033.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Reserves:")]), _vm._v(" Following mobilisation there would be approximately 50,000 Armed Forces personnel available. Conscription, currently six months should cease by the end of 2010.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("EU Battlegroups")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Austria is a member of the EU Battlegroup which includes contingents from Germany and the Czech Republic.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Austria – Army – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "38.79%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "61.21%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Main Battle Tanks (MBT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("114 x Leopard 2A4")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Light Tanks")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("120 x Kuerassier SK-105 (of which about 60 are in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Infantry Fighting Vehicles (IFV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("105 x Ulan (Tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Personnel Carrier (APC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("250 x Saurer 4K series (Tracked) of which about 100 are believed to be in store")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("70 x Pandur (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("20 x Dingo (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Self Propelled Artillery (SP ARTY)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("180 x M-109 variants (Tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Towed Artillery")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("80 x 105 mm (in store) and 20 x 155 mm (in store – some 120 mm used for training)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Multiple Rocket Launchers (MRL)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("16 x 128 mm M-51 (in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mortars (Mor)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x 107 mm (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("200 x 120 mm (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x 82 mm Granatwerfer (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Anti-Tank (Atk)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("80+ x Jaguar with HOT (in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("300 x RBS-56 Bill (about 100 in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1,000 x 84 mm Carl Gustav")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Plus 66 mm LAW; Panzerfaust 3; 74 mm Miniman")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Low Level Air Defence (LLAD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("34 x Mistral SAM (under Air Force Command control with about 40 in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("70 x 20 mm FIAK 65/68 (gun system – in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("70 x 35 mm ZFIAK with Skyguard (gun system – in store)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("AUSTRIAN AIR FORCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Air Force (Air Force Command) Strength: approximately 2,500 professionals and approximately 1,000 conscripts (total 3,500))")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Austrian Air Force Command Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0036.jpg",
      "src": "images/e9781783032051_i0036.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Air Surveillance/Defence Group –")]), _vm._v(" Consists of fixed radar sites, mobile radar stations and Mistral SAM. 2 x Typhoon are generally held on QRA (quick reaction alert) to intercept unidentified aircraft.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fliegerregiment 1 with 4 x Squadrons:")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Squadron 1 – AB 212 (transport/utility helicopter)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Squadron 2 – AB 206A and OH 58 Kiowa (liaison, recce and training helicopters)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Squadron 3 – AB 206A and OH 58 Kiowa (liaison, recce and training helicopters)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Squadron 4 – PC-6 Turbo Porter (fixed wing transport)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fliegerregiment 2 with 2 x Squadrons:")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Squadron 1 – 15 x Typhoon")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Squadron 2 – SA 3160 and SA316B Allouette III (utility helicopters)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fliegerregiment 3 with 3 x Squadrons")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Squadron 1 – AB 212 (transport/utility helicopter)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Squadron 2 – AB 206 (transport/utility helicopter)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Squadron 3 – 28 x SAAB 105 (trainers and FGA)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Austria – Air Force – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "42.07%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "57.93%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighter (Ftr)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("15 x Typhoon (Tranche 1 Block 5)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport (Tpt)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x C-130K Hercules")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10 x PC-6B Turbo Porter")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Training (Trg)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("25 x Saab 105")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("16 x PC7 Turbo Trainer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air to Air Missiles (AAM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Sidewinder AIM-9")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("IRIS-T")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("11 x OH 58 Kiowa (observation and recce)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("11 x AB 206 (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("20 x AB 212 (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9 x S70A Black Hawk (support)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("22 x SA-319 Allouette 3 (utility)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CURRENT UNIT DEPLOYMENTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "47.37%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "52.63%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("(over platoon strength – 30 personnel. These are approximate figures)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EUFOR Bosnia")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 100")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("KFOR Serbia/Kosovo")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 450")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("UN (UNDORF) Syria/Israel")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 375")])])])])])])]), _c('a', {
    attrs: {
      "id": "title66"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title66"
    }
  }), _c('a', {
    attrs: {
      "id": "title67"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("BELGIUM")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("BELGIUM – BASIC FACTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "46.67%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "53.33%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10.3 million")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence budget 2010:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 2.8 billion (US$3.4 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GDP 2009:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 320 (US$390 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land area:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("30,200 sq kms (11,615 sq miles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Capital:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Brussels (Population 980,000)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Life expectancy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("79 years")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population growth rate:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("0.3 per cent")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Total Armed Forces")])]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army (Land Component):")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("14,200")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Navy (Maritime Component):")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1,600")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Force (Air Component):")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("7,000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Joint Service Component:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("13,500")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Medical Component:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1,800")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Reserves:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2,000 (approximately)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MINISTRY OF DEFENCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contact Details")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Ministry of Defence")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Rue Lambermonstraat 8")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("B-1000 Bruxelles")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("BELGIUM")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Tel: +32 2 507 6611")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Fax: +32 2 507 6651")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ARMY (LAND COMPONENT)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army Strength")]), _vm._v(": approximately 14,200")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In general terms and available for immediate operations are:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("7 x Infantry battalions (including 3 x para commando)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Tank battalions")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Armoured reconnaissance battalion")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Special forces group")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("4 x Artillery battalions (including 1 x observation and surveillance)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Engineer battalions")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("5 x Communications groups")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("7 x Logistic/combat support battalions")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Anti-tank helicopter battalions")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Liaison helicopter battalion")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The following diagram shows the outline structure of the Belgian Land Forces (Army)")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "76%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0040.jpg",
      "src": "images/e9781783032051_i0040.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Notes:")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) The HQ of Army Operational Command (Land) and 1 Mechanised Brigade plus 7 Mechanised Brigade form the Belgian contribution to the Eurocorps.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) The Rapid Reaction Group (Para Commando) is Belgium’s immediately deployable force.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(3) Command Troops include an Intelligence Group (with a Special Forces component), an Engineer Group, an Artillery Group and a Communications Group.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(4) The Army Aviation Group is part of the Air Component but available for joint operations.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Belgian Mechanised Brigade Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0041.jpg",
      "src": "images/e9781783032051_i0041.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Note:")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Rapid Reaction Group (Para Commando) has 3 x Para Commando Battalions. The 3rd Parachute Battalion stationed at Antwerp forms the initial entry battalion of the NATO Response Force (NRF) and is integrated into the Franco-German Brigade.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Reserves")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("There are two main elements. The Ordinary Reserve and the Volunteer Reserve; the compulsory reserve consists of ex conscripts and former regular personnel. The Volunteer Reserve consists of volunteers, some of whom may not have had prior military service. A Special Reserve Group consists of personnel who have agreed to serve for a specified period during peace should the need arise.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("EU Battlegroups")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Belgium is a member of two EU Battlegroups. The first is a French-Belgian Battlegroup and the second a Battlegroup that includes contingents from Germany, France, Luxembourg and Spain.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Belgium – Army – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "37.31%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "62.69%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Main Battle Tanks (MBT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("50 x Leopard 1A5 (Operational – to be phased out by 2011)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Infantry Fighting Vehicles (AIFV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("30 x YPR-765 (some with 25 mm gun)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Personnel Carrier(APC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("50 x M-113 (Tracked")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("60 x Pandur (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("45 x Piranha IIIC (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("75 x Dingo (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Self Propelled Artillery (SP Arty)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("51 x M-109 variants (Tracked) (in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Towed Artillery (Towed)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("24 x 105 mm Light Gun")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Mortars (Mor)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("30 x 120 mm (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("42 x 81 mm (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("50 x 60 mm (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Anti-Tank (Atk)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("90 x Milan ATGW (estimate in service)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("200 x 66 mm/112 mm (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Low Level Air Defence (LLAD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("30 x Mistral SAM (under Air Force Command control)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NAVY (BELGIAN NAVAL COMPONENT)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Navy Strength")]), _vm._v(": approximately 1,600")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Principal units:")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Frigates")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("6 x Mine Warfare Vessels")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Belgian Navy Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "71%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0044.jpg",
      "src": "images/e9781783032051_i0044.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Operational command of Belgian and Netherlands naval (surface) forces is delegated to the Admiral Benelux command at Den Helder. The ABNL has a bi-national structure with a modular approach to operations, training and logistics, this results in the Comopsnav only performing tasks not delegated to the ABNL.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Belgium – Navy – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "39.89%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "60.11%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Frigates (FF)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Karel Doorman")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mine Hunter Coastal (MHC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x Tripartite (Aster)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Miscellaneous")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x Support Vessels")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Naval Aviation")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x SA-316B (available from the Air Component)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x Sea King Mk 48 (Search and Rescue)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("AIR FORCE (BELGIAN AIR COMPONENT)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Air Force Strength")]), _vm._v(": approximately 7,000")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Outline structure")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0046.jpg",
      "src": "images/e9781783032051_i0046.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Notes:")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) The helicopter group has the 3 x A 109 squadrons that were previously part of the Army Aviation Group. For operations these squadrons could be placed under the control of the Army Operational Command. The helicopter group also includes the 4 x search and rescue (SAR) Sea Kings.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) Major Airbases are located at Beauvechain, Florennes. Kleine Brogel, Melsbroek, Koksijde (Coxyde) and Bierset.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Belgium – Air Force – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "37.13%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "62.87%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighter Ground Attack (FGA)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Approx 60 x F-16 MLU in operational service with some 28 in store")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Electronic Intelligence (ELINT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x DA-20 Falcon")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport (TPT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("11 x C-130H Hercules")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x A-310-200")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Falcon 900")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x ERJ-135")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x ERJ-145")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Falcon 20")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Training (Trg)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("26 x Alpha Jet")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("23 x SF 260MB")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9 x SF 260 D")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("25 x A-109")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x SA-318")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Sea King Mk 48 (SAR)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Unmanned Air Vehicles (UAV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("18 x B-Hunter")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air launched missiles (ALM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AMRAAM AIM-120 AAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Sidewinder AIM-9 AAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AGM-65 Maverick ASM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Surface to Air Missiles (SAM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("24 x Mistral SAM launchers")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CURRENT UNIT DEPLOYMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("(over platoon strength – 30 personnel. These are approximate figures)")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("NATO (ISAF) Afghanistan")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("- 500 (includes 4-6 x F-16)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("EUFOR Central African Republic/Chad")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("- 75")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("NATO (KFOR)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("- 200")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NATO Headquarters")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The following major NATO headquarters are situated in Belgium:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Supreme Headquarters Allied Powers Europe – Brussels")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Allied Command Operations – Brussels")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("NATO Programming Centre – Glons")])])])])]), _c('a', {
    attrs: {
      "id": "title67"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title67"
    }
  }), _c('a', {
    attrs: {
      "id": "title68"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("BULGARIA")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Bulgaria – Basic facts")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "43.80%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "56.20%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("7.4 million")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence budget 2010:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 761 million (US$936 million)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GDP 2009:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 34 billion (US$42 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land area:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("111,000 sq kms (42,857 sq miles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Capital:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Sofia (Population 1.4 million)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Life expectancy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("72.8 years")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population growth rate:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("-0.77 per cent")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Total Armed Forces")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "61.25%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "38.75%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("16,000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Navy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3,500")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Force:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6,500")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Joint (Central Staff):")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8,500")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Conscription ended in 2008 and the above approximate personnel figures continue to be reduced.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("There are approximately 12,000 Border Guards serving under the command of the Ministry of the Interior.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MINISTRY OF DEFENCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contact Details")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Ministry of Defence")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("3 Dyakon Ignatiy Street")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1000 Sofia")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("BULGARIA")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Tel.: +35 9 02 92 20 922")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Bulgaria joined the European Union in January 2007 following its accession to NATO in April 2004. The Bulgarian Ministry of Defence is still involved in a restructuring programme (PLAN 2004) that will see its military forces based around a core rapid reaction force.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ARMY (Land Forces)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army Strength")]), _vm._v(": 16,000 approximately\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Armoured Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Mechanised Brigades")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Light Infantry Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Special Forces Brigade")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Outline Structure")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "63%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0051.jpg",
      "src": "images/e9781783032051_i0051.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note: Some sources suggest that up to 4 x Reserve Brigades and about 200,000 reservists would be available in an emergency. While the reserve forces are almost certainly significant, our estimate is that only one or two reserve Brigades with between 10,000 to 15,000 personnel could realistically be expected to be available for operations at short notice.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("EU Battlegroups")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Bulgaria is a member of the HELBROC Battle Group. This battle group which consists of contingents from Cyprus, Greece, Romania and Bulgaria can only be deployed for evacuation operations and for humanitarian assistance.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Bulgarian – Army – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "56.04%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "43.96%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Main Battle Tanks (MBT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("160 x T-72M (possibly 250 in-store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Reconnaissance (Recce)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x BRDM-2 (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Infantry Fighting Vehicles (AIFV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x BMP-2/3 (Tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("75 x BMP-1 (Tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Armoured Personnel Carrier (APC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("100 x MTLB (Tracked) (possibly 600 in-store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("100 x BTR-60PB-MD1 (Wheeled) (possibly 100 in-store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("7 x M1117 (Wheeled) for Afghanistan")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Light Vehicles (Lt Veh)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("300 Mercedes G Class (300 more on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("50 x HMMWV (for Afghanistan)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Self Propelled Artillery (SP Arty)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("150 x 122 mm 2S1 (possibly 500 in-store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Towed Artillery (Towed Arty)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("100 x 122 mm D-20 with about 300 other types")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("such as 130 mm M-46, 122 mm M-30, various")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("100 mm in store")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Multiple Rocket Launchers (MRL)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("100 x 122 mm BM-21 (possibly 100 in-store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Mortars (Mor)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("200 x 120 mm 2S12")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("200 x 82 mm")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Anti-Tank (Atk)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("200 x AT-4/AT-5 (some AT-5 SP)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Variety of 85 mm and 100 mm AT guns in store")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Air Defence (AD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("24 x SA-8 SAM SP")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("40 x SA-9 SAM SP")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("10 x SA-5 SAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("100 x SA-7 SAM (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Variety of older guns available")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "colspan": "2"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Note :")]), _vm._v(" Many of the above equipment figures are probably optimistic. It is unlikely that a force at 18,000 personnel would be capable of managing all of the equipment listed above.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NAVY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Navy Strength")]), _vm._v(": approximately 3,500\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Submarine")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("4 x Frigates")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("17 x Mine Warfare Vessels")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Major naval bases are located at Varna and Atiya.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Bulgaria – Navy – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "36.48%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "63.52%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Submarines (SSK)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Slavat (Soviet Romeo Class)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Frigates (FF)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Pauk")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Smeli (Soviet Koni Class)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Drazki (Belgian Weilingen Class – one more on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Corvettes (FS)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Gowind on order from France for deliveries starting in 2012")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mine Hunter Coastal (MHC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Tripartite MHC (Belgian/Flower Class)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Sonya MHC")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Vanya MHC")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x Olya MSI")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Patrol Vessels (PC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Tarantul II")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x Osa I/II")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9 x Zhuk")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Miscellaneous")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x landing ships")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x logistics and support vessels")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Naval Aviation")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Mi-14 (being replaced by AS-565)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x AS-565 Panther (deliveries start in 2010)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("AIR FORCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Air Force Strength")]), _vm._v(": approximately 6,500")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Outline structure")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "71%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0055.jpg",
      "src": "images/e9781783032051_i0055.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes: 22 (Attack) Air Base is in the process of becoming a joint US/Bulgarian training facility.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Bulgaria – Air Force – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "43.71%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "56.29%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighter/Interceptor (Ftr)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("20 x MiG-29 Fulcrum (modernisation complete")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("15 x MiG-21 Bis/UM (reported as serviceable")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighter Ground Attack (FGA)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x Su-25/Su25UB (operational)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport (Tpt)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x An-24")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x C-227J Spartan (3 more on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x An-26")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("7 x Let-410UVP-E")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x PC-12M")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x An-30 (also used for survey)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Training (Trg)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x L39ZA")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x PC-9M")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x Bell 206 (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x AS 532 Cougar (transport & SAR)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x Mi-17 (transport)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x Mi-24D/V (attack)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Defence (AD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("SA-5 SAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("SA-10 SAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("(Probably 50-60 launchers available)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air launched missiles (ALM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AA-2, AA-7, AA-10 & AA-11 AAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AS-7, AS-10 & AS-14 ASM")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CURRENT UNIT DEPLOYMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("(over platoon strength – 30 personnel. These are approximate figures)")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "69.90%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "30.10%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (ISAF) Afghanistan")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 450")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (KFOR) Kosovo")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 50")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EUFOR Bosnia")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 120")])])])])])])]), _c('a', {
    attrs: {
      "id": "title68"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title68"
    }
  }), _c('a', {
    attrs: {
      "id": "title69"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CYPRUS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CYPRUS – BASIC FACTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "38.77%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "61.23%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1,000,000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence budget 2010:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 450 million (US$550 million)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GDP 2009:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 19.6 billion (US$24 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land area:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9,200 sq kms (3,538 sq miles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Capital:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Nicosia (Population 195,000)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Life expectancy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("78 years")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Population growth rate:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("1.3 per cent")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Total Armed Forces")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "28.95%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "71.05%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army (National Guard):")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10,000 (including about 9,000 conscripts and approximately 400")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_vm._v("Maritime and Air Wing personnel). Possibly 50,000 ready reservists available.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Maritime Wing:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 (approximate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Wing:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("300 (approximate)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Conscripts serve for around 25 months.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Some 35,000 Turkish troops are stationed in the northern part of the island (Turkish Republic of Northern Cyprus) and have been there since the invasion of 1974. In 1983 the United Nations Security Council Resolution 541 stated that the “attempt to create the Turkish Republic of Northern Cyprus was legally invalid”.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Cyprus remains divided into Greek Cypriot and Turkish areas and the Greek Cypriot part of the island has membership of the European Union. A United Nations Peacekeeping Force (UNFICYP) with about 860 personnel is stationed along the buffer zone (Green Line) between the two communities.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("There is considerable input from the mainland Greek Armed Forces (about 1,500 personnel) and possibly a slight ‘blurring’ of the command responsibilities between the Cypriot Government and the Greek Ministry of Defence in Athens. A Greek officer is generally the commander of the Cypriot National Guard and a number of the senior command and staff appointments are held by Greek military officers.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The UK has 1,600 personnel stationed on the island.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MINISTRY OF DEFENCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contact Details")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Ministry of Defence")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("4 Emm Roidi Street")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Nicosia")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("CYPRUS")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Tel: +357 2 303189")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Fax: +357 2 362605")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Greek Cypriot National Guard (GCNG) – Land Operations Group")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GCNG Strength")]), _vm._v(": approximately 10,000 (including about 9,000 conscripts). Approximately 50,000 ready reservists.\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Divisional Headquarters")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Armoured Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Special Forces Group")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Combat/Logistic Support Brigades")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This is a force that is heavily reliant on the mobilisation of reserves and it is debatable as to how many well trained, ready reserve personnel would be available in an emergency. Probably about 60% of the active GCNG soldiers are deployed along the ‘Green Line’ between the Greek Cypriot and Turkish Cypriot areas.")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "72%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0061.jpg",
      "src": "images/e9781783032051_i0061.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Formed reserve forces units include 6 x light infantry brigades each with 3 x infantry battalions and associated support.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cypriot Armoured Brigade (Outline Organisation)")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0062.jpg",
      "src": "images/e9781783032051_i0062.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Greek Cypriot National Guard – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "48.55%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "51.45%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Main Battle Tanks (MBT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("41 x T-80U")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x AMX-30")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Reconnaissance (Recce)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("15 x EE-3 Jacaranda (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("120 – EE-9 Cascavel (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Infantry Fighting Vehicles (AIFV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("40 x BMP-3 (Tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Personnel Carrier(APC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("160 Leonadis (Tracked))")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("112 x VAB variants (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Self Propelled Artillery (SP Arty)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x 155 mm Mark F3")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x 155 mm Zuzana")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Towed Artillery (Towed)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("70 x 105 mm M-56")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x 155 mm TR-F-1")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Multiple Rocket Launchers (MRL)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("18 x 128 mm M-63")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mortars (Mor)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x 120 mm (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("200 x 81 mm (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("20 x 107 mm (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Anti-Tank (Atk)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("22 x HOT possibly 15 SP (ATGW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("40 x Milan possibly 18 SP (ATGW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("50 x 106 mm (RCL) (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("40 x EM-67 (RCL) (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Approx 1,500 rocket launchers (66 mm to 112 mm)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Low Level Air Defence (LLAD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("6 x TorM1 (SAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("100 x SA – 7B ( SAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("12 x Mistral/Atlas (SAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("18 x Mistral Manpads (SAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("12 x Aspide (SAM) (12 more on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("24 x GDF-003 with Skyguard radar (AAA)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Approx 50-60 other 20 mm or 40 mm guns (AAA)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Maritime Wing")]), _vm._v(": strength approximately 100")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Principal units:")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("6 x Small coastal patrol vessels")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Coastal defence battery with 3 x Exocet MM-40 (SSM) launchers and 24 x missiles")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This extremely small maritime unit is equipped for inshore patrolling and a basic search and rescue role. Main bases are at Limasol and Paphos.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Air Wing:")]), _vm._v(" strength approximately 300")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The role of the GCNF Aviation Wing is to provide avaition support to the land forces and where necessary provide patrol duties (including maritime patrol) plus liasion and transport.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("There are two main aviation bases:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("449 Squadron – Lakatamia")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("5 x SA-342L, 2 x UH-1H and 2 x Bell 206L-3")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("450 Squadron – Paphos")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x PC-9, 11 x Mi-35P and 1 x BN-2B")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Cyprus Police operates 1 x BN.2B and 2 x Bell 412SP from Larnica.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Greek Cypriot National Guard – Aviation Wing – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "36.59%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "63.41%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport (TPT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x PC-9")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x BN-2B-21 Maritime Defender")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x SA-432L (some with HOT ATGW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x UH-1H")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Bell 206L")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("11 x Mi-35P Hind F (attack)")])])])])])])]), _c('a', {
    attrs: {
      "id": "title69"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title69"
    }
  }), _c('a', {
    attrs: {
      "id": "title70"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CZECH REPUBLIC")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CZECH REPUBLIC – BASIC FACTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "40.29%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "59.71%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10.2 million")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence budget 2010:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 1.91 billion (US$2.3 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GDP 2009:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 172 billion (US$210 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land area:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("62,100 sq kms (23,885 sq miles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Capital:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Prague (Population 1.1 million)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Life expectancy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("75 years")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population growth rate:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("0.0 per cent")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Total Armed Forces")])]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land Forces:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12,500 (including about 1,000 civilians)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Navy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Landlocked country – no naval forces")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Force:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5,000 (including about 750 civilians)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("MoD Central Staff")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6,000 (being reduced)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MINISTRY OF DEFENCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Since 2005 the Czech Armed Forces (ACR) have been engaged in a major transformation effort that should be complete by the end of 2012. This transformation effort will ensure that the ACR is able to meet its NATO and EU commitments, especially the inclusion of Czech force elements in the EU’s tri-national German, Austrian and Czech Battlegroup.\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contact Details:")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Ministry of Defence")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Delostrelecka 11")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("160 02 Prague 6")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Czech Republic")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CZECH LAND FORCES")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Land Forces strength:")]), _vm._v(" 12,500 (including about 1,000 civilians)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Major formations include:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Rapid Deployment Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Mechanised Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Artillery Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Engineer Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Logistic Support Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x NBC Protection Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Special Forces Brigade")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The following diagram shows the current outline structure of the Czech Land Forces:")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "83%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0067.jpg",
      "src": "images/e9781783032051_i0067.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) 4 Rapid Deployment Brigade has 2 x mechanised battalions, 1 x airborne battalion and one light infantry battalion plus combat support and logistic support units.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) 7 Mechanised Brigade has 2 x mechanised battalions, 1 x light infantry battalion and 1 x tank battalion plus combat support and logistic support units.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(3) 13 Artillery Brigade has 2 x combined artillery battalions.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(4) 15 Engineer Brigade, 14 Logistic Support Brigade, 31 NBC Protection Brigade, 101 Signal Battalion, 103 Psyops Group and 104 Support Battalion are all Joint Force Support Units available for support to both land and air forces.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Reserves:")]), _vm._v(" The Active Reserve of the ACR consists of approximately 2,000 personnel on three year contracts who are formed into a number of company groups. The major reserve element consists of 14 x infantry companies, each with five platoons: 3 x rifle platoons; 1 x command and combat support platoon and 1 x logistic support platoon.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Czech Land Forces – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "47.37%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "52.63%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Main Battle Tanks (MBT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("150 x T-72M4CZ (majority in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Infantry Fighting Vehicles (AIFV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("200 x BMP-1 (Tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("150 x BMP-2 (Tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x BPzV (Tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Personnel Carrier(APC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x OT-90 (Tracked) (possibly 30 in service)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("18 x OT-64 (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x Dingo 2 (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("19 x Panther (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("234 x Pandur 2 on order")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Self Propelled Artillery (SP Arty)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("48 x 152 mm M-77 Dana (about 150 more in")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Towed Artillery (Towed)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("120 x 122 mm D-30 (majority in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Multiple Rocket Launcher (MRL)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("16 x 122 mm M-70 (about 40 in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mortars (Mor)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("80 x 120 mm (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Anti-Tank (Atk)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("20 x AT-5 on BRDM-2")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("150 x AT-4 (Manpack)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Some AT-3 remain in service")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CZECH AIR FORCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Air Force strength: 5,000 (including about 750 civilians)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Czech Air Force outline structure is as follows:")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "70%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0069.jpg",
      "src": "images/e9781783032051_i0069.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) The Air Maintenance Centre is at Ceskeioyice Budeioy.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) 26 CCS is an airspace command, control and surveillance formation.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(3) Joint Force Support Formations such as 15 Engineer Brigade, 14 Logistic Support Brigade, 31 NBC Protection Brigade, 101 Signal Battalion, 103 Psyops Group and 104 Support Battalion are all available to provide support for air operations.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Units and aircraft are as follows:")])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "44.10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "22.71%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "33.19%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("21 Tactical Air Base")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("211 Squadron")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("JAS Grippen")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("212 Squadron")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("L-159A")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("22 Airbase")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("221 Squadron")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("L-39")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("222 Squadron")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("L-39")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("23 Helicopter Base")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("231 Squadron")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Mi-24")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("232 Squadron")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Mi-17")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("233 Squadron")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("W-3A")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("24 Transport Base")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("241 Squadron")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("An-26, L.410, Yak-40, TU-154, CL-601")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("242 Squadron")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Mi-8, Mi-17, W-3A")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Air Training Centre")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("L-39C, L-410Mi-2, Z-142")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Czech Air Force – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "38.37%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "61.63%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighter Ground Attack (FGA)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x JAS 39C Grippen")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x JAS-39D Grippen")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10 x L-159 Albatross (about 50 more available for sale)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport (TPT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x An-26")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x CL-601 (VIP)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x L-410 Turbolet")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Airbus A-319")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x C-295M")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Training (Trg)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x Z-142C")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("25 x L-159 (some in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x L-410")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x EW-97")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x Mi-24 Hind (Attack – some in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10 x Mi-35 (Attack)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10 x W-3A (Support)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("25 x Mi-17 (Support)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Unmanned Air Vehicles (UAV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x Sojka")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air launched missiles (ALM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AIM-9 Sidewinder, AMRAAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Defence")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("16 x RBS-70, SA-6 SAM, SA-8 SAM, SA-13 SAM")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CURRENT UNIT DEPLOYMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("(over platoon strength – 30 personnel. These are approximate figures)")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "63.55%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "36.45%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (ISAF) Afghanistan")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 600")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (KFOR) Kosovo")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 400")])])])])])])]), _c('a', {
    attrs: {
      "id": "title70"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title70"
    }
  }), _c('a', {
    attrs: {
      "id": "title71"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("DENMARK")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("DENMARK – BASIC FACTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "39.70%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "60.30%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5.4 million")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence budget 2010:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 3.3 billion (US$4.0 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GDP 2009:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 226 billion (US$275 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land area:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("42,400 sq kms (16,308 sq miles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Capital:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Copenhagen (Population 1 million)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Life expectancy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("76 years")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population growth rate:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("0.3 per cent")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Note from the Danish Ministry of Defence:")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("“Denmark has since 1993 had an EU opt-out in the area of defence. The opt-out means that Denmark does not participate in EU decisions and actions which have defence implications. This includes participation in EU military operations and participation in EU military capability development efforts”.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Total Armed Forces")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "39.65%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "60.35%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10,200 (including about 2,000 conscripts)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Navy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3,200 (including about 200 conscripts)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Force:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3,250 (including about 150 conscripts)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Joint Units and Staff")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6,000 (approximately)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Home Guard:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("50,000 (approximately)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MINISTRY OF DEFENCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contact Details")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Ministry of Defence")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Holmens Kanal 42")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("DK-1060 Kobenhavn K")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("DENMARK")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Conscripts serve for between 4 – 12 months.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("DANISH ARMY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army Strength")]), _vm._v(": 10,200 (including about 6,000 conscripts)")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Outline Army Structure")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In general terms Danish Army formations are grouped together under the overall framework of the Danish Division.")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "59%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0076.jpg",
      "src": "images/e9781783032051_i0076.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Divisional troops include:")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x standing telegraph battalion (Fredericia)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x electronic reconnaissance company (Fredericia)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x military police company – cadre (Aalborg)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x engineer battalion (Skive)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x artillery battery – target acquisition (Oksbøl)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x UAV battery (Oksbøl)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x air-defence missile battery (Varde)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x CIMIC company (Vordingborg)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x communications unit and communication centre (Haderslev)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("1 Brigade structure")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In the main this brigade is composed of professional soldiers and is dedicated to NATO at high readiness.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Brigade staff and brigade support company (Hadersley)\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x armoured battalion (Holstebro)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x mechanised infantry battalion (Hovelte)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x reconnaissance battalion (Slagelse)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x light reconnaissance squadron (Bornholm)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x logistics battalion (Aalborg)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x military police company (Aalborg)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x armoured engineer company (Skive)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x artillery battery (Varde)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("2 Brigade Structure")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This brigade is composed mainly of personnel on response force contracts. 2 Brigade is also dedicated to NATO but at lower readiness.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Brigade staff and brigade support company (Hadersley)\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x mechanised infantry battalion – cadre (Hovelte)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x mechanised infantry battalion – cadre (Slagelse))")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x mechanised infantry battalion – cadre (Holstebro)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x armoured engineer company – cadre (Skive)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x artillery battery – cadre (Varde)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x logistics battalion – cadre (Aalborg)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x military police company – cadre (Aalborg)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x light reconnaissance squadron – cadre (Bornholm)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Danish Army – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "37.25%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "62.75%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Main Battle Tanks (MBT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("51 x Leopard 2A5")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("40 x Leopard 1A5 (possibly active – probably 60 in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Reconnaissance (Recce)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("30 x MOWAG Eagle 1 (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Infantry Fighting Vehicle (AIFV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("45 x CV 9035 III (being delivered)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Personnel Carrier (APC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("250 x M-113 (Tracked – possibly active – many more in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("118 x Pirhana III (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("85 x MOWAG Eagle IV (Wheeled – being delivered))")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Towed Artillery (Towed)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("24 x 105 mm M-101 (estimate in service)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("80 x 155 mm M-114/M-139 (in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Self Propelled Artillery (SP Arty)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("24 x M-109 variants (probably 50 in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Multiple Rocket Launchers (MRL)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x 227 mm MLRS (in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mortars (Mor)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x 120 mm Brandt (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("300 x 81 mm (estimate – includes about 50 x SP)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("50 x 60 mm (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Anti-Tank (Atk)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("20 x TOW ATGW (with about 20 on M113 in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("500 x 84 mm Carl Gustav (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5,000 x 84 mm AT-4 (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Low Level Air Defence (LLAD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("24 x Stinger (SAM – estimate in service)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Unmanned Air Vehicle (UAV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x Sperwer (estimate)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("DANISH NAVY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Navy Strength")]), _vm._v(": approximately 3,200 (including about 200 conscripts)")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Principal units:")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("3 x Patrol Vessels (Corvettes)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("6 x Mine Countermeasures Vessels")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("10 x Smaller Patrol Vessels")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Surveillance and Reconnaissance Vessels")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Whilst having the ability to concentrate on littoral tasks the Danish Navy retains the operational capability to participate in NATO’s Standing Naval Forces. In addition, participation in the NATO Response Force is to be prioritised.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Danish Navy Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "75%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0078.jpg",
      "src": "images/e9781783032051_i0078.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) Danish Task Group (DATG) is the coordinating HQ for combined and joint exercises/operations. In essence all Danish vessels can be assigned to the DATG.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) Special Forces (Frogmen Corps) consist of about 90 highly trained personnel.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(3) EOD - Explosive Ordnance Demolition Group.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(4) SRCC - Search and Rescue Coordination Centre.")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("1 Squadron assets")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("4 x Thetis Class offshore patrol vessels (Frederikshavn)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Fishery protection vessels (Frederikshavn)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Training vessels (Frederikshavn)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Transport vessel (Frederikshavn)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("3 x Ice breakers (Frederikshavn)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("6 x Mk II units (Korsor)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Surveillance vessels (Korsor)")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("2 Squadron assets")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Support vessels (Frederikshavn)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("4 x Mine countermeasures vessels (Frederikshavn)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("3 x Niel Juel Corvettes (Korsor)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("10 x Standard Flex 300 vessels (Korsor)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Danish Navy – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "56.91%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "43.09%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Corvettes")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Niel Juel")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Patrol Craft Coastal (PCC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Barsoe")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Agdlek")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Diana")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Patrol Craft Offshore (PCO)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Thetis")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fast Patrol Craft (PFC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x Flyvefisken")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mine Countermeasuresl (MHC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Flyvefisken")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Miscellaneous")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("7 x Support Vessels")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Naval Aviation")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x Super Lynx Mk 90")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note: The Naval element of the Home Guard has 9 x small patrol vessels")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ROYAL DANISH AIR FORCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Air Force Strength")]), _vm._v(": approximately 3,250 (including about 150 conscripts)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Outline structure")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("There are two major air force commands:")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0080.jpg",
      "src": "images/e9781783032051_i0080.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Operational combat aircraft (FGA) comprise 48 x F-16A/B Fighting Falcon from a total of 60. Of these aircraft eight are at high readiness, eight at lower readiness and both groups are designated for NATO operations.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("There are both fixed wing and rotary wing aircraft at high readiness and designated for NATO operations. The Royal Danish Air Forces Denmark continues to participate in the Joint Strike Fighter project.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("There is a NATO air defence Control Reporting Centre (CRC) based at Karup which coordinates information from four radar sites.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Squadron aircraft")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "36.96%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "13.47%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "49.57%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("721 Sqn")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Lockheed C-130J, Canadair 604")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("722 Sqn")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EH101 Merlin")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("724 Sqn")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Hughes H500M, AS550C2 Fennec")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("726 Sqn")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Lockheed F-16a/B Fighting Falcon")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("727 Sqn")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Lockheed F-16a/B Fighting Falcon")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("730 Sqn")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Lockheed F-16a/B Fighting Falcon")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Flying School")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Saab T 17 Supporter")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Royal Danish Air Force – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "36.86%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "63.14%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighter Ground Attack (FGA)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Approx 48 x F-16AM/F-16BM in service with some 22 in store")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport (TPT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x C-130J-30 Hercules")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Canadair CL-604")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Training (Trg)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("28 x T-17 SAAB Supporter")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x EH101 Merlin (6 more awaiting delivery)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x AS 550C2 Fennec (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("13 x Hughes H500M")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Unmanned Air Vehicles (UAV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("18 x B-Hunter")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air launched missiles (ALM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AMRAAM AIM-120 AAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Sidewinder AIM-9 AAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AGM-65 Maverick ASM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Surface to Air Missiles (SAM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("24 x Stinger SAM (estimate)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Danish Home Guard")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Danish Home Guard (DHG) is a volunteer organisation can be mobilised to support the Armed Forces or the civilian authorities in either peace or war.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The DHG supports the armed forces with the following branches:\n")])]), _vm._v(" "), _c('ul', {
    staticClass: "bl"
  }, [_c('li', {
    staticClass: "bsl"
  }, [_vm._v("Army Home Guard")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Naval Home Guard")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Air Force Home Guard")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Infrastructure Home Guard")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The overall mission for the Home Guard is to reinforce and to support the Army, the Navy, and the Force in fulfilling their missions. Related to their overall mission, the common military tasks of the Home Guard are:\n")])]), _vm._v(" "), _c('ul', {
    staticClass: "bl"
  }, [_c('li', {
    staticClass: "bsl"
  }, [_vm._v("Surveillance and reporting")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Guarding, securing, and protection activities")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Limited involvement in combat operations")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Latest figures suggest that the DHG has around 50,000 personnel with elements supporting the three armed services. About 3,500 are serving with infrastructure elements. Volunteers serve until the age of 50.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CURRENT UNIT DEPLOYMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("(over platoon strength – 30 personnel. These are approximate figures)")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "66.01%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "33.99%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (ISAF) Afghanistan")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 700")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (KFOR) Kosovo")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 275")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NATO Headquarters")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The following major NATO headquarters is situated in Denmark")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Combined Air Operations Centre – Finderup:")])])])]), _c('a', {
    attrs: {
      "id": "title71"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title71"
    }
  }), _c('a', {
    attrs: {
      "id": "title72"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ESTONIA")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ESTONIA – BASIC FACTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "41.86%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "58.14%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1.3 million")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence budget 2010:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 246 million (US$300 million)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GDP:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 22.2 billion (US$27.2 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land area:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("42,300 sq kms (16,269 sq miles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Capital:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Tallinn (Population 404,000)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Life expectancy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("71 years")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population growth rate:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1.2 per cent")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Total Armed Forces")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "34.98%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "65.02%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4,300 (including about 2,000 conscripts)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Navy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("300")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Force:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("300")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence League:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10,000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Border Guard:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2,250")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The planned size of the mobilisation (wartime) structure is 16,000 personnel which includes about 10,000 from the Voluntary Defence League.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Conscription")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Conscripts serve for between 8 to 11 months, depending on the education and role. Following conscript service personnel are called up for a short period of reserve training every five years.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Estonia is a participant in the Nordic Battle Group which has other contingents from Sweden, Finland, Norway and Ireland.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MINISTRY OF DEFENCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contact Details")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Ministry of Defence")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Sakala 1")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("EE-15094 Tallinn")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ESTONIA")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Tel: +372 640 6012")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Fax: +372 640 6001")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ESTONIAN ARMY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("4,300 personnel (which includes about 2,000 conscripts)")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Army component of the Estonian Defence Forces consists of an infantry brigade and a homeland security structure.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Estonian Army Outline Organisation (Mechanised)")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "72%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0087.jpg",
      "src": "images/e9781783032051_i0087.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Note:")]), _vm._v(" The 3 x infantry Battalions are named Kuperjanov, Pärnu, and Viru.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Estonia – Army – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "50.32%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "49.68%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Personnel Carrier (APC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("20 x BTR-80 (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("50 x Sisu XA-180 (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6e x Bv-206 (Tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Towed Artillery (Towed)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("24 x 105 mm M 61-37")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("24 x 155 mm FH-70")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mortars (Mor)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("50 x 81 mm (estimate in service)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x 120 mm (estimate in service)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Anti-Tank (ATK)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10 x Milan ATGW")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x 84 mm Carl Gustav")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x PV-1110")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Low Level Air Defence (LLAD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Possibly 20+ x ZSU 23-2")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("25 x Mistral 2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Estonian Voluntary Defence League has 15 Military Districts with about 10,000 personnel.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ESTONIAN NAVY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(Personnel 300)")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Estonian Navy is responsible for protecting the territorial waters of the Republic of Estonia and cooperation with the Baltic Naval Squadron.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Baltic Naval Squadron – BALTRON was inaugurated in 1998. The main responsibility of BALTRON is to improve the co-operation between the Baltic States in the areas of naval defence and security. Constant readiness to contribute units to NATO-led operations is assured through BALTRON. Each Baltic state appoints one or two ships to BALTRON for certain periods and staff members for one year.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("There are bases at Tallinn and Miinisadam.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Estonia – Navy – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "46.71%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "53.29%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Corvette (FS)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Admiral Pitka (76 mm gun)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mine Hunter Coastal (MHC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Admiral Cowan (ex UK Sandown)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Minelayer (ML)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Lindormen")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ESTONIAN AIR FORCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(Personnel 300)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The small Estonian Air Force was re-established in December 1991 and consists of three units; Air Force Headquarters, the Ämari Air Base and Air Surveillance Wing.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Air Force Headquarters has the Air Force Command and Control Centre included in its structure. The Command and Control Centre analyses the Air Force missions, manages the airspace, plans and controls the air defence, air attack and air transport flight operations.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The air surveillance system is currently being enhanced with the installation of the TPS-117 long-range primary radar.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Estonia – Air Force – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "46.91%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "53.09%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport (Tpt)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x AN-2 Colt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Training (Trg)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x PZL-104 Wilga")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Robinson R44")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CURRENT UNIT DEPLOYMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("(over platoon strength – 30 personnel. These are approximate figures)")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("NATO (ISAF) Afghanistan")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("- 150")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("NATO (KFOR) Kosovo")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("- 30")])])])])])])]), _c('a', {
    attrs: {
      "id": "title72"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title72"
    }
  }), _c('a', {
    attrs: {
      "id": "title73"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("FINLAND")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("FINLAND – BASIC FACTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "41.05%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "58.95%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5.2 million")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence budget 2010:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 2.7 billion (US$3.2 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GDP 2009:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 173 billion (US$211 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land area:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("304,600 sq kms (117,606 sq miles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Capital:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Helsinki (Population 1.16 million)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Life expectancy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("78 years")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population growth rate:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("0.3 per cent")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Total Armed Forces")])]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("16,000 (including about 11,000 conscripts)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Navy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3,800 (including about 1,800 conscripts)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Force:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2,750 (including about 750 conscripts)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Frontier Guard:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3,000")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MINISTRY OF DEFENCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contact Details")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Ministry of Defence")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Eteläinen Makasiinikatu 8")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("PO Box 31")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("FIN-00131 Helsinki, Finland")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Tel.: +358 9 16001")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Fax: +358 9 653 254")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Reserves")]), _vm._v(": Following mobilisation there would be approximately 100,000 reserves for the field army and some 200,000 local and territorial reserve personnel for other units.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Conscripts serve for between 6 to 12 months and about 35,000 reservists complete reserve training for about one month a year (more for some specialists and officers). The reserve obligation ceases at age 60 for officers and aged 50 for others.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("EU Battlegroups")]), _vm._v(": Finland is a participant in 2 x EU Battlegroups and is a member of the Nordic Battlegroup (with Sweden, Estonia, Ireland and Norway) and Battlegroup 107 (with Germany and the Netherlands).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ARMY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army Strength")]), _vm._v(": 16,000 (including about 11,000 conscripts)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("From 2010 the core elements of the standing force consist of the following:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Special Forces Battalion (Erikoisjääkäripataljoona)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Mechanised Battle Groups")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("3 x High Readiness (Jaeger) Brigades")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("5 x Regional Combat Groups")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Helicopter Battalion")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("A Rapid Reaction Group will be drawn from the units above.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Support troops include:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Communications Battalion")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Air Defence Battalions")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Combat Support Group")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Logistics Support Group")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("With the exception of the rapid reaction group, the majority of the above units require reservist personnel to enable them to reach their full deployment strength.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Following mobilisation the following formations and units could be available from the reserve forces:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("9 x Jager Brigades")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Armoured Brigades")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("6 x Infantry Brigades (Type 80)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Artillery Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("16 x Engineer Battalions")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("3-4 x Air Defence Battalions")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In total some 100+ x infantry battalions and independent companies might be available following mobilisation.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army Commands")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Military Operations are controlled by Army Headquarters in Helsinki through 3 x major commands as follows:")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "64%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0093.jpg",
      "src": "images/e9781783032051_i0093.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("As part of a planned restructuring process military provinces are being established as follows:\n")])]), _vm._v(" "), _c('ul', {
    staticClass: "bl"
  }, [_c('li', {
    staticClass: "bsl"
  }, [_vm._v("Eastern Military Province Headquarters in Kouvola")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Savo-Karelia Military Province Headquarters in Kuopio")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Northern Military Province Headquarters in Oulu")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Lapland Military Province Headquarters in Rovaniemi")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Western Military Province Headquarters in Hameenlinna")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Ostrobothnia Military Province Headquarters in Vaasa")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Southern Military Province Headquarters in Helsinki")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("High Readiness (Jager) Brigade Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0094.jpg",
      "src": "images/e9781783032051_i0094.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Finland – Army – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "48.64%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "51.36%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Main Battle Tanks (MBT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("90 x Leopard 2A4 (probably 100 in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("400 x T-72 (in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Infantry Fighting Vehicle (AIFV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("150 x CV9030 (deliveries continue)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x BMP-2 (probably 200 in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Personnel Carrier (APC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("250 x XA-180 and XA-185 (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x XA-200 series (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x MTLB types (tracked – possibly 200 in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Self Propelled Artillery (SP Arty)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("70 x 122 mm PsH 74 (Soviet 2S1)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("20 x 152 mm 2S5")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Towed Artillery (Towed Arty)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Approx 650 all types available: Mainly 122 mm H-63 (D-30); some 152 mm H-55 (D-20); 105 mm H-61; 152 mm H88-38; 152 mm H88-40; 130 mm K 89;")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Multiple Rocket Launchers (MRL)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("30 x 122 mm H-89 (Soviet RM-70)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("22 x 227 mm MLRS (from Netherlands)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mortars (Mor)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Approx 600 x 120 mm and 1,500 x 82 mm")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Anti-Tank (AT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("30e x AT-5 (ATGW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("20e x AT-4 (ATGW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12e x TOW 2 (ATGW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("80e x Spike (ATGW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army Aviation (Helicopters)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10 x NH90TTT (12 more on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Mi-8P/8T Hip")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x MD500D/E")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("18 x Attack Helicopters planned")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Low Level Air Defence (LLAD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Some 100 – 150 x LLAD Guns in service.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("20e x Crotale NG (SAM-90)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("15e x RBS ASRAD (SAM-05)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("90e x SA-11 (SAM 96 – being replaced)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100e x SA-16/18 (SAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100e x RBS 70 (SAM)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NAVY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Navy Strength")]), _vm._v(": 3,800 (including about 1,800 conscripts). In general conscripts serve for between 6 to 12 months.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Principal units:")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("8 x Fast Patrol Craft")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("18 x Mine warfare vessels")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Finnish Navy Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "69%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0096.jpg",
      "src": "images/e9781783032051_i0096.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) The Naval Headquarters is currently moving from Helsinki to Turku.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) The Usimiaa Brigade which is composed of Coastal Jaegers (marines). This Brigade is equipped with Euro-Spike (SSM) and truck mounted RBS-15 Mk3 (SSM)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The major effective units of the Finnish Fleet are the missile and minewarfare squadrons. These major units are deployed with the Archipelago and Gulf of Finland Naval Commands. Both of these Naval Commands include some environmental protection vessels that are under the ownership of the Finnish Ministry of Interior.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Finland – Navy – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "46.46%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "53.54%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fast Patrol Craft (PFM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Rauma Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Hamina Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Patrol Craft (PC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Kiiska Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mine Sweeper Inshore (MSI)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x Kuha Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("7 x Kiiski Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Minelayers (ML)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Hameenmaa Class (150 mines)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Pansio Class (50 mines)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Pohjanmaa Class (150 mines)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Landing Craft Utility (LCU)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Kala Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Kampella Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Icebreakers (AGB)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9 x various")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Miscellaneous")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Command Vessel")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9 x Survey Vessels")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("15 x Light Stores Vessels")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Ocean Research Vessel")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Transport Vessels")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Note:")]), _vm._v(" Under Project 2010 the Navy will receive three mine countermeasures vessels (MCMV) which should be in service by 2012. Vessels are being built by Intermarine (Italy) at a cost of Euros 244 million (US$326 million).")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("AIR FORCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Air Force Strength")]), _vm._v(": 2,750 (including about 750 conscripts)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Finnish Air Force Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "70%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0098.jpg",
      "src": "images/e9781783032051_i0098.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note: There are three fighter wings - one in each Air Command/Air Defence Area.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Northern Air Command")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Air Defence Flights with F-18C/D (11 Squadron)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Training Flight with Hawk Mk51/51A")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Communications/Transport Flight with PA-28; Redigo; Vinka and PA-31")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Eastern Air Command")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Air Defence Flights with F-18C/D (31 Squadron)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Training Flight with Hawk Mk51/51A")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Communications/Transport Flight with PA-28; Redigo; Vinka and PA-31")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Western Air Command")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Air Defence Flights with F-18C/D (21 Squadron)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Training Flight with Hawk Mk51/51A")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Communications/Transport Flight with PA-28; Redigo; Vinka and PA-31")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Air Force Training Squadron")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Training Flight with L-70 (41 Squadron)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Training Flight with Hawk Mk51/51A")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Training Flight with Hawk Mk51; Redigo; L-70 and PA-28")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Simulation Flight")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Air Force Headquarters")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x ASW/Maritime Surveillance Flight with F-27 and Learjet 35A")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Communications/Transport Flight with PA-28; Redigo; Vinka and PA-31")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Electronic Warfare Flight")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Finland – Air Force – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "48.41%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "51.59%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighter Ground Attack (FGA)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("56 x F/A-18C Hornet")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("7 x F/A-18D Hornet")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Maritime Reconnaissance (MR)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x F-27-100 Maritime Enforcer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport/Liaison (TPT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Learjet 35")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Casa C-295")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x PA-31-350")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Training (TRG)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("48 x Hawk Mk 50/51A (attack trainer)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("18 x Hawk Mk 66 (attack trainer)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("28 x L-70 Vinka")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9 x Redigo")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air to Air Missiles (AAM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AMRAAM AIM-120")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Sidewinder AIM-9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Frontier Guard operates 3 x AS 332L Super Puma, 3 x Augusta AB 412EP and 3 x AB 206/A/B Jet Ranger helicopters.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CURRENT UNIT DEPLOYMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("(over platoon strength – 30 personnel. These are approximate figures)")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("NATO (ISAF) Afghanistan")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("- 165")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("NATO (KFOR) Kosovo")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("- 400")])])])])])])]), _c('a', {
    attrs: {
      "id": "title73"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title73"
    }
  }), _c('a', {
    attrs: {
      "id": "title74"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("FRANCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("FRANCE – BASIC FACTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "42.05%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "57.95%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("65 million")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence budget 2010:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 32.1 billion (US$39.1 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GDP 2009:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 1,920 billion (US$2,342 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land area:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("674,843 sq kms (260,558 sq miles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Capital:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Paris (Population 2.2 million)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Life expectancy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("80 years")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population growth rate:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("0.55 per cent")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Total Armed Forces")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "37.09%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "62.91%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Approximately 112,800")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Navy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Approximately 42,000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Force:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Approximately 57,000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Medical Service:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8,500")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Central Staff:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5,000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Gendarmerie:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("101,000")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Army Reserves consist of about 18,000 personnel with a number of personnel in 100 company sized (120 personnel) formed units ready for immediate recall. Both the Air Force and the Navy each have about 6,000 reserve personnel available for recall.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Strategic Nuclear Strike Force (Force De Frappe)")]), _vm._v(" This consists of a submarine based element with submarine launched ballistic missiles and an air launched element with aircraft carrying the nuclear armed missile ASMP/ASMP-A.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MINISTRY OF DEFENCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contact Details")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Ministry of Defence")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("14 Rue St Dominique")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("F-75997 Paris Armees")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("France")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("EU Battlegroups")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("France is a participant in 3 x EU Battlegroups. The first is a completely French Battlegroup, the second is a Battlegroup with French, German, Belgian, Spanish and Luxembourg contingents and the third a French – Belgian Battlegroup.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ARMY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army Strength")]), _vm._v(": Approximately 112,800 with about 18,000 ready reserves.\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Land Forces HQ")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("4 x Task Force HQs (Divisional Size)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("5 x Regional HQ")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Under the command of the following are:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Light Armoured Brigades")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Heavy Armoured Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Mechanised Brigades")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Airborne Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Reconnaissance Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Engineer Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Communications Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Artillery Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Aviation Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Intelligence/Surveillance Brigade")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The following diagram shows the current outline structure of French Army deployable formations:")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "70%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0103.jpg",
      "src": "images/e9781783032051_i0103.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) Expect brigades to have their integral artillery, engineer, logistic, maintenance and medical support. There are other independent units providing combat support and logistic support.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) Expect the Artillery, Engineer, and Intelligence/Surveillance Brigades to provide appropriate support to the combat formations. The majority of these units are under the direct command of 2 CFT. The Airmobile Brigade was disbanded in 2010 and aviation units dispersed to the deployable iormations.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(3) There are 5 x Regional Headquarters located at Bordeaux; Lyon; Metz; Rennes; Saint-Germain-en- Lave. Each of these Regional Headquarters has units that provide administrative and logistic support.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Special Operations Command (COS)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The formation is built around a core group of about 2,500 personnel as follows:")])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "26.21%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "73.79%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1st Parachute Regiment (SAS type unit)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("13th Regiment of Dragoons (Parachute capable reconnaissance unit)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Aviation detachment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Navy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x Marine Commando Units")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Counter terrorist unit")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Force:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport Operations Group (C-130 and C-160)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Rotary Group")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Parachute Commandos")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("There are other units of the armed forces in direct support and in reserve.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Rapid Reaction Corps HQ (Lille)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This is a French Army Headquarters with about 450 personnel (or 750 following mobilisation) that has been established to act as a Corps Headquarters (2 x divisions plus) for a multinational formation under either French or European Union command. Personnel from other European nations serve with the headquarters on a permanent basis.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("French Foreign Legion")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Consists of about 7,600 personnel in 9 x Regiments located as follows:")])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Mainland France")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("6 regiments")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Corsica")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("1 regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Djibouti")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("1 regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("French Guyana")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("1 regiment and 1 detachment")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("About 25 per cent of the personnel are believed to be French with the rest being foreigners.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("French Mechanised Brigade")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The following diagram illustrates the possible composition of a French Mechanised Brigade with about 5,500 personnel.")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "72%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0106.jpg",
      "src": "images/e9781783032051_i0106.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Other specialist units would be allocated depending upon the operational requirement.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("France – Army – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "48.14%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "51.86%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Main Battle Tanks (MBT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("400 x Leclerc (over 100 in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("200+ x AMX-30 (majority in store – possibly 20 being used for training)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Reconnaissance (Recce)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("200 x AMX-10RC (Wheeled – over 100 more in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("180 x ERC-90 (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("300 x VBL M-11 (Wheeled – estimate in service)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Infantry Fighting Vehicles (AIFV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("630 x VBCI (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("500 x AMX-10P (Tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Personnel Carrier (APC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2000 x VAB (possibly 2,000 more in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("25 x VAB NBC")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Self propelled Artillery (SP Arty)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("30 x 155 mm Ceasar (42 more on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("72 x 155 mm AuF-1 (being replaced by Ceasar)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Towed Artillery (Arty)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("80 x 155 mm TR-F-1")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Multiple Rocket Launchers (MRL)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("40 x 227 mm MLRS (possibly 20 more in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mortars (Mor)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("300 x 120 mm")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Anti-Tank (Atk)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("99 x VAB with HOT (SP ATGW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x VAB with Milan (SP ATGW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("175 x VAB with Eryx (SP ATGW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("500 x Milan (ATGW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("1,500 x 84 mm AT4 (RL)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Low Level Air Defence (LLAD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("20 x I-Hawk MiM-23B (Towed)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("882 x Mistral (MANPAD)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Unmanned Air Vehicle")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("30 x CL-289")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("15 x Sperwer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Army Aviation")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("80 x Tiger (Attack)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("250 x SA-342 Gazelle (Attack – many in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("35 x NH-90 (Support)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("8 x EC 725 (Support)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("126 x SA-330 Puma (Support)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("24 x AS-532 Cougar (Recce and Utility)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("FRENCH NAVY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Navy Strength:")]), _vm._v(" Approximately 42,000")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Principal units:")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("4 x Strategic (Ballistic Missile Submarines)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("6 x Attack Submarines")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Aircraft Carriers")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("12 Destroyers")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("20 x Frigates")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("French Navy Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "72%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0109.jpg",
      "src": "images/e9781783032051_i0109.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) The French naval element of the Strategic Nuclear Force (FOST) is based at Ile Longue near Brest. FOST consists of 4 x Le Triomphant su}omarines each with 16 x M45 SLBM (submarine launched ballistic missiles). Each missile has 6 x warheads. At least one submarine is at sea at any one time and the permission to launch can only be given by the President of the Republic.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) In mainland France naval units are stationed at: Cherbourg, Brest, Ile Longue, Lorient, Bayonne and Toulon. Naval bases overseas are at Fort de France, Degrad des Cannes; Dakar, Djiloouti, Abu Dhabi, Port des Galets. Noumea, Papeete.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(3) French Naval Aviation (AVIA) consists of approximately 150 aircraft and some 6,800 pilots of whom about 400 are pilots. Naval Air Bases are at Nimes, Landivsiau, Lann-Bihoue, Hyeres, Tontouta and Lanveoc-Poulmic. The aircraft carrier Charles De Gaulle is a maior AVIA element.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(4) The Naval Amphibious & Special Forces Group (FORFUSCO) consist of 8 x amphiloious and support vessels. There are about 1,800 Marines organised in 2 x battalions (Toulon and Brest) plus 7 x units of company plus size varying from 100 - 150 personnel. About 600 Commandos are organised into specialist elements such as assault. reconnaissance, raiding, combat divers and support. The Commandos are assigned to the French Special Forces Command.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(5) The Maritime Gendarmerie consists of about 1,000 personnel operating about 30 small vessels. There are 3 x commands (Atlantic, Channel and Mediterranean) and a small unit in Paris operating on the River Seine.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("French Navy – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "38.80%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "61.20%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Ballistic Missile Submarines (SSBN)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Le Triomphant submarines each with 16 x M-45 SLBM (submarine launched ballistic missiles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Submarines Tactical (SSK)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x Rubis (6 x Barracuda class ordered – first in 2010)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Aircraft Carrier (CV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Charles De Gaulle (CVN – nuclear powered)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Jeanne d’ Arc (CVH – helicopters)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Frigates (FF) Destroyers (DG)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Horizon Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Cassard Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("7 x Georges Leygues Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Tourville Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x La Fayette Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x Floreal Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9 x D’Estienne d’ Orves Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("11 x Aquitaine Class on order (First for delivery in 2010 – final in 2022)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mine Warfare (MW)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("11 x Eridan (MHC)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Loire (MCM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Vulcain (MCD)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Antares (MCV)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Amphibious (Amphib)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Foudre (LPD)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Mistral (LPD) (1 more on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("15 x Assorted LCT/LCM/LST")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Patrol and Coastal Combatants (PCC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Albatross Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Laperouse Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9 x L’Audacieuse Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Flammant Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Grebe Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Athos Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Miscellaneous")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Laperouse Class (Hydrographic Survey)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Durancce Class (Oilers)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Dupuy (Intelligence)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Naval Aviation")])]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Shipborne Aircraft")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("28 x Rafale M F3 (Ftr) (possibly 9 x M F1 in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("40 x Super Etendard 11F/17F (Attack)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Note:")]), _vm._v(" Both types of the above aircraft are capable of launching the nuclear armed ASMP/ASMP-A")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Maritime Patrol (MP)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("22 x Atlantique")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Reconnaissance (Recce)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Falcon 200")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Falcon 50")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Airborne Early Warning (AEW)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x E-2C Hawkeye")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Support & Training")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9 x SA 365 Dauphin (SAR)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x SA 321 Super Frelon (SAR)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x Falcon 200 (Support)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("11 x Embracer Xingu (Support)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9 x MS88 Rallye (Trg)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9 x CAP 10 (Trg)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Missiles (Msls)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("ASMP (ASM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AM-39 Exocet (ASM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("MICA (AAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AS 30 (AAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Helicopters")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("25 x HAS.2 Lynx (ASW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("16 x AS 565 Panther (Attack)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("10 x AS 33365 Dauphin (SAR)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("8 x SA 321 Super Frelon (SAR)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("24 x Allouette III (Support)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("FRENCH AIR FORCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Air Force Strength")]), _vm._v(": Approximately 57,000 (reducing) with about 800 aircraft and approximately 5,000 ready reserves.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Forces Available:")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "47.35%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "52.65%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Strike:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Squadrons")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Recce:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Squadrons")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Defense:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Squadrons")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighter Ground Attack:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Squadrons")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Electronic Warfare:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Squadron")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Multi-role:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Air Defence Squadrons")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Airborne Early Warning:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Squadron")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("7 x Transport Squadrons")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Utility:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("7 x Utility Squadrons")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Rotary:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x Helicopter Squadrons")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("French Air Force Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "71%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0113.jpg",
      "src": "images/e9781783032051_i0113.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) CFAS conunands the Air Force element of the French Strategic Nuclear Force. In general terms this force consists of 3 x squadrons of Mirage M-2000N aircraft armed with ASMPiASMP-A nuclear capable missiles. Approximately 60 x M-2000N are availahle and they are supported by about 14 x air to air refuelling tankers (possiloly 3 x KC-135 and 11 x C-135FR).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) Airbases are established on a regional command network as follows: Northern Region 16 airbases and the Southern Region which has 50 airbases. There are airloases and detachments overseas at Abu Dhabi, Dakar, Djibouti, Reunion, Martinique, Guyana, N’djamena and New Caledonia.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(3) Airbase security is provided by 30 x security groups and there are 3 x Air Force Commando units (Special Forces).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("French Air Force – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "33.58%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "66.42%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Strike")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("60 x Mirage M-2000N with ASMP/ASMP-A nuclear capable missile.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Multi-role")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("30 x Rafale F2B/C")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("28 x Rafale F3B/C (total of 120 x Rafale F3B/C on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighters (FTR)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("20 x Mirage M-2000-5")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("48 x Mirage M-2000C")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Fighter Ground Attack (FGA)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("21 x Mirage F-1CT")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("61 x Mirage M-2000D")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Reconnaissance (Recce)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("32 x Mirage F-1CR")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Electronic Warfare (EW)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("2 x C-160G Gabriel")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Airborne Early Warning (AEW)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("4 x E-3F Sentry")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Transport (Tpt)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("5 x C-130H")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("40 x C-160 Trans all")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("3 x A-310-300")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("2 x A-340-200")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("2 x A-319")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("3 x Falcon 50; 2 x Falcon 900")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("5 x DHC-6")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Air to Air Refuelling (AAR)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("3 x KC-135")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("11 x C-135FR")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("15 x Transall C-160")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Training (Trg)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("85 x Alpha Jet")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("15 x Grob G120")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("25 x Tucano")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("21 x Xingu EMB-121")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("5 x CAP-10")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("6 x AS-332 Super Puma (Support)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("24 x SA-330 Puma (Support)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("2 x AS-532 Cougar (Utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("40 x AS-555 Fennec")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("6 x EC 725 (SAR)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Low Level Air Defence (LLAD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("36 x Crotale/Crotale NG launchers (estimate in service)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Some Mistral MANPAD")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Some 20 mm (AAA)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Air launched missiles (ALM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Mica (AAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("R-550 Magic 2 (ASM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Apache (ASM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("SCALP (ASM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("AS30L (ASM)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GENDARMERIE")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gendarmerie Strength")]), _vm._v(": Approximately 101,000 with about 25,000 ready reserves.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Under the operation budget of the French Home Office the Gendarmerie is an armed force that provides units that are the operational control of the armed forces. In addition, the Gendarmerie is responsible for providing a police response in areas outside of the main cities – covering about 50 per cent of the population. The Gendarmerie is also responsible for police duties in French overseas territories.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In support of the armed forces the Gendarmerie deploys about 28 x VBC-90 (Lt Tanks); 150 x VBRG-170 (Wheeled APC); 4 x Patrol Craft; 30 x motor launches; 20 x EC 135 and 10 x EC 145 helicopters.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CURRENT UNIT DEPLOYMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("(over platoon strength – 30 personnel. These are approximate figures)")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "70.47%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "29.53%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (ISAF) Afghanistan")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 3,100")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Caribbean")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 1,350")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Central African Republic")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 250")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Chad")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 1,200")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Cote D’ Ivorie")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 800")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Djibouti")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 1,500")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("French Guyana")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 1,400")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("French Polynesia")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("- 1,500")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Gabon")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("- 700")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Germany")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("- 2,800")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("UNIFIL II – Lebanon")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("- 1,,500")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("New Caledonia")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("- 1,500")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("NATO (KFOR) Kosovo")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("- 1,300")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Reunion")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("- 1,400")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Senegal")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("- 850")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Tajikistan")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("- 150")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("UAE")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("- 200 (estimate)")])])])])])])]), _c('a', {
    attrs: {
      "id": "title74"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title74"
    }
  }), _c('a', {
    attrs: {
      "id": "title75"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GERMANY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GERMANY – BASIC FACTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "39.42%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "60.58%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("82 million")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence budget 2010:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 31.1 billion (US$37.9 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GDP 2009:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 2,280 billion (US$2,781 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land area:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("357,500 sq kms (137,200 sq miles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Capital:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Berlin (Population 3.3 million)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Life expectancy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("79 years")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population growth rate:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("0.3 per cent")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Total Armed Forces")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "21.04%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "78.96%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("160,000 including about 40,000 conscripts (plus about 130,000 reserves)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Navy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("24,000 including about 3,500 conscripts (plus about 4,000 reserves)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Force:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("50,000 including about 10,000 conscripts (plus about 12,000 reserves)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Bundeswehr (the generic name for the German Armed Forces) is currently restructuring. During early 2010 conscription was reduced from 9 to 6 months and it is possible that there are longer term plans to abolish conscription entirely.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("We believe that under the current limitations imposed by the German constitution it is unlikely that the Armed Forces are capable of deploying more than about 10,000 personnel on overseas missions.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MINISTRY OF DEFENCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contact Details")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Ministry of Defence")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Stauffenberg Strasse 18")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("D-10785 Berlin")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GERMANY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Operations Division at the Federal Ministry of Defence includes the newly formed Response Forces Operational Command.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The German Armed Forces are being restructured and by 2012 there should be three categories of forces – Response Forces, Stabilisation Forces and Support Forces with all three armed services contributing forces as required. There is a Joint Forces Support Service and a Central Medical Service.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GERMAN ARMY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Restructuring")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("By late 2011 the following formation reductions will have been achieved.:")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Divisional headquarters reduced from 8 to 5")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Active brigades reduced from 17 to 12")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Battalions reduced from 120 to around 70 (depending on future planning assumptions)")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("These reductions will result in a force grouped around:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Response Forces")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Special Operations Division")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 (GE) Armoured Division")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Stabilisation Forces")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("10 (GE) Armoured Division")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("13 (GE) Mechanised Division")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Airmobile Division (DLO)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Support Forces")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Army Support Command")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army Strength")]), _vm._v(": approximately 160,000 including about 40,000 conscripts (plus about 130,000 reserves). There would appear to be plans to reduce the size of the German Army to 132,000 within two or three years.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In general terms and available for immediate operations are:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Armoured Divisions")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Mechanised Division")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Airmobile Division")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Special Operations Division")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("German element of the Franco/German Brigade")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The following diagram shows the current outline structure of the German Army:")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0120.jpg",
      "src": "images/e9781783032051_i0120.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) Expect brigades to have their integral artillery, engineer, logistic, maintenance and medical support.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) The Army Office is responsilole for doctrine. future concepts, training, army schools, colleges and administration.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(3) In the following references to divisional formations all German divisions are prefixed by GE to avoid confusion with other national formations.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Overall there are approximately 70 battalions (major units).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The following diagram illustrates the possible composition of a German Brigade – In this case the 12th Armoured Brigade.")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "70%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0121.jpg",
      "src": "images/e9781783032051_i0121.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Specialist units such as artillery and air defence would be allocated depending upon the operational requirement.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Multinational operations")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Significant elements of the Germany Army are earmarked for multi-national operations in support of either NATO (Article V – General War) or the European Union as follows:")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("I (German/Netherlands) Corps")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This corps headquarters in Munster deploys 1 (GE) Armoured Division and the Dutch 1 (NL) Division under NATO Article V arrangements.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Multinational Corps North East (MNC NE)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("With its headquarters located in Sczcecin this Corps has a Mechanised Division assigned. Both Denmark and Poland contribute forces to this formation as equal partners.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("2 (German/US) Corps")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Located in Ulm this headquarters is a NATO HQ available as a force headquarters for Article V operations. In a purely national context this HQ assists with training and national planning tasks.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("5 (US/German) Corps")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("With its headquarters located in Heidelberg this corps has German formations assigned for Article V operations.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Eurocorps")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This headquarters is located in Strasbourg and the main German contribution is 10 (GE) Armoured Division as well as the German units assigned to the Franco/German Brigade. Other national contributions are from Belgium, France, Luxembourg and Spain. The Eurocorps organisation is covered in detail in earlier chapters.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("European Union Battlegroups")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Germany has agreed to participate in the following 4 x European Union Battlegroups that are to be operational by 2012:\n")])]), _vm._v(" "), _c('ol', {
    staticClass: "al"
  }, [_c('li', {
    staticClass: "asl"
  }, [_vm._v("France, Germany, Belgium, Luxembourg")]), _vm._v(" "), _c('li', {
    staticClass: "asl"
  }, [_vm._v("Germany, the Netherlands and Finland")]), _vm._v(" "), _c('li', {
    staticClass: "asl"
  }, [_vm._v("Germany, Austria and the Czech Republic")]), _vm._v(" "), _c('li', {
    staticClass: "asl"
  }, [_vm._v("Poland, Germany, Slovakia, Latvia")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Allied Command Europe Rapid Reaction Corps (ACE ARRC)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This multi-national Corps with its headquarters in The United Kingdom has German formations assigned.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("German Army – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "39.55%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "60.45%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Main Battle Tanks (MBT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("About 1,000 x Leopard operational with 350 to be upgraded to A6. Running down to a force of 852 x Leopard in total.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Reconnaissance (Recce)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("80 x TPz-1 Fuchs (NBC) (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("222 x Fennek (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Infantry Fighting Vehicles")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("(AIFV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("410 x Puma (Tracked – replacing Marder)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("170 x Wiesel (Tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Personnel Carrier (APC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("900 x M-113 (Tracked – estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("900 x TPz-1 Fuchs (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("200 x Dingo (Wheeled – 598 on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Self Propelled Artillery (SP Arty)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("490 x 155 mm M-109A3G (Tracked and majority in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("165 x 155 mm PzH 2000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Towed Artillery (Towed)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("50 x 105 mm M-101 (Estimate – in reserve)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("60 x 155 mm FH-70")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Multiple Rocket Launcher (MRL)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("130 x 227 mm MLRS")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mortars (Mor)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("400 x 120 mm Tampella/Brandt (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Anti-Tank (Atk)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1000 x Milan ATGW (estimate in service)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x TOW ATGW (SP on Wiesel – estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Low Level Air Defence (LLAD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("30-40 x Roland SAM (in service)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("50 x ASRAD-R SP SAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1,000 x Stinger SAM (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("28 x PAC-3 Patriot SAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("147 x 35 mm Geppard")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1,000 x 20mm (approximately)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army Aviation")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("150 x BO-105 with HOT ATGW (Attack)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("90 x CH53G Stallion (Support)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("13 x EC-135 (Utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("15 x SA 313 Alouette II (Utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x UH-1D Iroquois (Utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("80 x Tiger (Attack – on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("80 x NH-90 (Support – on order)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Note:")]), _vm._v(" Expect overall armoured vehicle totals to be cut by approximately 25 per cent by end 2012.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GERMAN NAVY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Navy Strength")]), _vm._v(": approximately 24,000 including about 3,500 conscripts (plus about 4,000 reserves).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Principal units:")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("12 x Submarines")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("15 x Frigates")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("10 x Patrol Craft")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("19 x Mine Warfare Vessels")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Published plans suggest that following restructuring the future German Navy will consist of about 90 vessels. This total will probably include 8 x submarines, 14 x frigates, 14 patrol and 20 x mine warfare vessels.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("German Navy Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "64%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0123.jpg",
      "src": "images/e9781783032051_i0123.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) The Naval Office is responsible for policy, doctrine, security, training, schools, personnel, medical services, armaments, supply and maintenance.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("German Navy – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "42.39%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "57.61%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Submarines Tactical (SSK)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x Type 206")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Type 212 (2 more on order – possible total of 8)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Frigates (FF)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Sachesen Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Brandenburg Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x Bremen Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Corvettes (FS)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Braunschweig (2 more awaiting delivery)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mine Countermeasures (MCM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9 x Frankenthal (Type 332)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x Kulmbach (Type 333)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x Ensdorf (Type 352) with Seehund ROV")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Patrol and Coastal Combatants (PCC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10 x Geppard (Type 143A)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Miscellaneous")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x Landing craft")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("18 x Support vessels (tankers, cargo, barracks etc)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Naval Aviation")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x DO 228 (Tpt)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x P-3C Orion (MR)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("22 x Sea Lynx Mk 88A (ASW/ASuW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("21 x Sea King Mk 41 (SAR)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("38 x NFH 90 on order")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GERMAN AIR FORCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Air Force Strength")]), _vm._v(": 50,000 including about 10,000 conscripts (plus about 12,000 reserves).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Future plans")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Germany will purchase 180 x Eurofighter Typhoon aircraft (deliveries in progress) at a cost of 19.5 billion Euros and up to 60 x A400M transport aircraft at a cost of 8.2 billion Euros. First deliveries for the A400M are planned for 2011. Up to 42 x NH 90 helicopters are also on order for the Air Force.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("We expect to see about 250 x combat aircraft in the German Air Force inventory by 2012.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("German Air Force Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "63%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0125.jpg",
      "src": "images/e9781783032051_i0125.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note: (1) Ground based air defence is an integral part of each of the 3 x Air Divisions.")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "72%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0126.jpg",
      "src": "images/e9781783032051_i0126.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) The Air Force Office is responsible for policy, doctrine, security, training, schools, personnel, medical services, armaments, supply and maintenance. Support command provides logistical and maintenance support services.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Air defence operations")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The assets of the German Air Force are an important element in the NATO air defence organisation in the Central Area. The Tactical Command North’s ICAOC (Interim Combined Air Operations Centres) at Kalkar, and the Tactical Command South’s ICAOC at Messtellen both report to the NATO CAOC at Uedem (Germany). Overall air defence operations are coordinated from the NATO Joint Force Component Command HQ (JFCC Air) at Ramstein (Germany).")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Land based air defence is structured around six squadrons equipped with Patriot SAM, six squadrons equipped with Hawk SAM and 14 squadrons equipped with Roland SAM. These SAM units are also embedded in the NATO early warning and air defence network.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("German Air Force Flying Wings")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "31.63%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "33.58%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "34.79%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Designation")])]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Aircraft Type")])]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Location")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighterbomber Wing 31")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Tornado")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Norvenich")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighterbomber Wing 32")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Tornado")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Lechfeld")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighterbomber Wing 33")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Tornado")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Buchel")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Reconnaissance Wing 51")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Tornado")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Kropp")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Transport Wing 61")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transall C-160D, Bell UH-1D")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Penzing")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Transport Wing 62")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transall C-160D, Bell UH-1D")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Holzdorf")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Transport Wing 63")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transall C-160D, Bell UH-1D")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Hohn")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighter Wing 71")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("F-4F Phantom/Typhoon")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Wittmundhaven")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighter Wing 73")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Tornado/Typhoon")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Laage")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighter Wing 74")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Tornado/Typhoon")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Neuburg/Donau")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Flight Service 1")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Airbus A 310 and Challenger")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Koln-Bonn")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Flight Service 3")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AS 532U2 Cougar")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Berlin-Tegel")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Test & Evaluation Wing 61")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("All types")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Manching/Ingolstadt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Training Wing")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Tornado")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Hollman AFB, New Mexico, USA")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("German Air Force Wings can have large numbers of aircraft – some Tornado Wings have as many 48 aircraft.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("German Air Force – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "43.02%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "56.98%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighters (FTR)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("40 x Typhoon (140 more on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("44 x F-4F Panthom II (until 2012)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Reconnaissance (Recce)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("41 x Tornado IDS")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighter Ground Attack (FGA)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("90 x Tornado IDS (in service)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Suppression of Enemy Air Defence")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("(SEAD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("32 x Tornado ECR")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport (Tpt)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("7 x Airbus A 310 (some tanker configuration)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("80 x C-160D Transall")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x CL-601 Canadair Challenger")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Training (Trg)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("35 x T37B")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("40 x T-38A")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("75 x UH-1D Iroquois (majority SAR)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x AS 532U2 Cougar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Up to 42 x NH 90 on order")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air launched missiles (ALM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AIM-9 Sidewinder (AAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("ASRAAM (AAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Iris T (AAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AGM-88A Harm (ARM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AGM-65 Maverick (ASM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AS-34 Kormoran (ASM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Surface to Air Missiles (SAM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("36 x Patriot SAM fire units")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("24 x Hawk SAM fire units (in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("45 x Roland SAM fire units (in store)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CURRENT UNIT DEPLOYMENTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "68.12%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "31.88%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (ISAF) Afghanistan")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 4,665")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (ISAF) Uzbekistan")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 175")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (KFOR) Kosovo")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 1,500")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EUFOR Bosnia")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 138")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("UNIFIL II – Lebanon")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 450")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Note:")]), _vm._v(" Considerable numbers of German Armed Forces personnel (both Army and Air Force) train at various locations in the United States using pre-positioned equipment.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NATO Headquarters")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The following major NATO headquarters are situated in Germany:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Joint Force Component Command Air – Ramstein")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Joint Force Component Command Land – Heidelberg")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Combined Air Operations Centre – Uedem")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("HQ Allied Command Europe Mobile Force – Heidelberg")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("HQ Reaction Force (Air) – Kalkar")])])])])]), _c('a', {
    attrs: {
      "id": "title75"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title75"
    }
  }), _c('a', {
    attrs: {
      "id": "title76"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GREECE")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GREECE – BASIC FACTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "28.32%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "71.68%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("11 million")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence budget 2010:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 6.7 billion (US$8.1 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GDP 2009:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 261 billion (US$318 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land area:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("131,900 sq kms (49,577 sq miles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Capital:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Athens (Population 3 million)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Life expectancy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("78 years")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population growth rate:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("0.4 per cent")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Total Armed Forces")])]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("90,000 including about 30,000 conscripts (plus about 150,000 ready reserves)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Navy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("16,000 including about 3,000 conscripts (plus about 6,000 reserves)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Force:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("30,000 including about 10,000 conscripts (plus about 20,000 reserves)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("National Guard:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("About 30,000 reserve personnel mainly organised for rear area security tasks")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Due to the difficult Greek financial situation, during early 2010 the Greek MoD announced a reduction in the length of conscripts service from 12 to nine months.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MINISTRY OF DEFENCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contact Details")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Ministry of Defence")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Mesogeion 227-231")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Holargos15451")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GREECE")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Tel.: +30 210 6598607")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Fax: +30 210 6443832")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GREEK ARMY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army Strength:")]), _vm._v(" approximately 90,000 including about 30,000 conscripts (plus about 150,000 ready reserves).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Greek Army outline structure")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "65%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0131.jpg",
      "src": "images/e9781783032051_i0131.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) Greece has joined the European Union Battlegroup structure and the Greek Army takes part with the Italian, Portuguese and Spanish armed forces in an amphibious role, by contributing a reinforced company of marines and a landing ship tank (LST).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) There is a Greek Mechanised Group (ELDYK) stationed in Cyprus and over 1,000 Greek officers and soldiers are serving on secondment with the Greek Cypriot National Guard.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(3) In the event of Army Corps C being deployed in a NATO mission, the Corps would operate as a multi-national force with contingents from a variety of NATO nations.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Corps Structure")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army Corps A")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("8 Infantry Division (Florian)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("3 x Infantry Brigades")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Armoured Brigade")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army Corps B")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 Army Division (Veroia)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Airmobile Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Marine Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Airborne Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 Mechanised Division (Edessa)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Mechanised Brigades")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Army Aviation Brigade")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army Corps C/NDC – GR HQ")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("12 Mechanised Division (Alexandroupoli)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Mechanised Brigades")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("26 Mechanised Division (Didimoteiho)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Mechanised Brigades")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("20 Armoured Division (Kavala)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("3 x Armoured Brigades")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Mechanised Brigade")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("("), _c('strong', {
    staticClass: "b"
  }, [_vm._v("NDC) – GR HQ")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Following the NATO Military Committee (MC) and the Nice EU Summit decisions in December 2000, the Hellenic Army General Staff decided to offer the ‘C’ Corps HQ as a candidate HQ to both the European Union and NATO:\n")])]), _vm._v(" "), _c('ol', {
    staticClass: "al"
  }, [_c('li', {
    staticClass: "asl"
  }, [_vm._v("To the European Union as Operational HQ for planning and directing autonomous, joint and combined EU-led operations.")]), _vm._v(" "), _c('li', {
    staticClass: "asl"
  }, [_vm._v("To NATO, as Deployable Land Headquarters for Forces at Lower Readiness -FLR (L) HQ, named NATO Deployable Corps (NDC) – GR HQ.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The headquarters is in Thessaloniki and the formation will be able to operate throughout the entire mission spectrum, ranging from peace support operations up to high intensity combat operations in any environment.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(NDC) – GR HQ includes contingents from Bulgaria, France, Germany, Italy, Poland, Romania, Spain and Turkey.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Islands and Interior Command")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("5 Infantry Division (Crete)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("79 National Guard Command (Samos)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("80 National Guard Command (Kos)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("88 Military Command (Myrimma)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("95 National Guard Command (Rhodes)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("96 National Guard Command (Chios)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("98 National Guard Command (Lesbos)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Future plans:")]), _vm._v(" the Greek Army continues to be involved in an extensive reorganisation programme. By 2015 a new brigade structure should be in place (The Strike Brigade) which will consist of six core battalions (4 x manoeuvre, 1 x artillery, 1 x combat support and various company sized elements such as engineers, communications and recce.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Greek Army – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "38.39%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "61.61%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Main Battle Tanks (MBT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("900 x Leopard (including some 180 x 2A4; 170 x 12A6 and about 500 1A5/GR)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("400 x M-60 (estimate – with many in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("600 x M-48 (majority in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Reconnaissance")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("About 200 x VBL (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Infantry Fighting Vehicles")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("the (AIFV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("370 x BMP-1 (tracked – majority probably in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Personnel Carrier (APC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("400 x Leonidas Mk1/Mk2 (tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1,500 M-113 types (tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("200 x M-577 (tracked ACV)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Self Propelled Artillery (SP Arty)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("300 x 155 mm M-109 (various types – our estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("36 x PzH 2000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("110 x M-110A2 (some in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Towed Artillery (Towed)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("200 x 105 mm M-101 (majority probably in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x Mod-56 Pack How")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("120 x 155 mm M-114 (majority probably in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Multiple Rocket Launchers (MRL)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("115 x 122 mm RM-70 Dana")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("36 x 227 mm MLRS")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mortars (Mor)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2,000 x 81 mm (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("400 x 120 mm (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("250 x 107 mm M-30 SP on M-106 (M-113 type)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Anti-Tank (Atk)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("300 x Milan ATGW (some SP)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("200 x AT-4 ATGW (some SP)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("196 x AT-14 (ATGW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("About 350 x TOW ATGW (some 320 SP on M-901)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("About 2,000 x 84 mm are Carl Gustav")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("About 1,300 x 106 mm M-40")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Low Level Air Defence (LLAD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("31 x SA-15 SAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("38 x SA-8B SAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("42 x I-HAWK")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("About 1,000 x Stinger SAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("About 500 x ZSU-23-2 AAA")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("About 250 x 20 mm RH-202 AAA")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("20 x AH-64A Apache (attack – to be upgraded to D standard)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("12 x AH-64D (attack – deliveries continue)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("8 x CH-47D Chinoonk (transport – 7 more on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("90 x UH-1H Iroquois (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("30 x AB-205A (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("12 x AB-206 (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Fixed Wing")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("38 x U-17A Skywagon (liaison)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("3 x C-12 Huron")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Unmanned Air Vehicles (UAV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("12 x Sperwer")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GREEK NAVY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Navy Strength")]), _vm._v(": approximately 16,000 including about 3,000 conscripts (plus about 6,000 reserves)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Principal units:")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("8 x Tactical Submarines")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("17 x Frigates and Corvettes")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("11 x Mine Warfare Vessels")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Major naval bases are at Patras, Salamis and Souda Bay in Crete")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Greek Navy Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "55%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0134.jpg",
      "src": "images/e9781783032051_i0134.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fleet Headquarters")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "80%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0135.jpg",
      "src": "images/e9781783032051_i0135.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) Naval operations is assisted by inputs from 353 Maritime Patrol Squadron (Air Force P-3B Orion aircraft).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Greek Navy – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "31.39%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "68.61%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Submarines")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x German Type 209 (Glavkos Class)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x German Type 214 (Poseidon Class – under construction)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Frigates (FF)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x MEKO 200HN (Hydra)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10 x Kortenaer (Elli)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Corvettes (FS)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Thetis (Niki)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fast Attack Craft (FAC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("15 x La Combattante (Types II, IIA, III and IIIB)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Hesperos (Jaguar)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("7 x Super Vita")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Andromeda")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Stamou")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Patrol Craft (PC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Armatolos (offshore)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Machitis (offshore)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Pyrpolotis (offshore)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mine Countermeasures")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Vessels (MCMV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x mine hunters")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x mine sweepers")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Miscellaneous")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("60 x Amphibious warfare vessels")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10 x Fleet support vessels (tankers, logistic etc)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Naval Aviation")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x PC-3B Orion (maritime reconnaissance)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x AB-212 EW (hel)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x AB212 ASW (hel)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("11 x S-70B-6 Aegean Hawk (attack hel)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Missiles")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Penguin ASM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("MM-40 Exocet ASSM")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GREEK AIR FORCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Air Force Strength")]), _vm._v(": approximately 30,000 including about 10,000 conscripts (plus about 20,000 reserves).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Outline structure")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "72%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0137.jpg",
      "src": "images/e9781783032051_i0137.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("NJote: (1) Air Training Command is responsible for air and ground training. (2) Air Support Command is responsilole for transport and anti-submarine warfare operations.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Tactical Air Command")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "72%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0138.jpg",
      "src": "images/e9781783032051_i0138.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) PM Stands for Fighter Wing. These 7 x Wings are composed of 16 x Squadrons plus some operational conversion units.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) The Independent Combat Groups are mainly Iocated on islands (Limnos; Aktion; Agrinion; Kastellion; Santorini and Skiros) and in the main host detachments from Tactical Air Command or transport aircraft from Air Support Command.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(3) Aircraft from HQ Tactical Air Command operate under NATO direction through the NATO CAOC (Combined Air Operations Centre) at Larissa.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Greek Air Force – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "53.33%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "46.67%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighter (Ftr)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("25 x Mirage 2000-5 Mk2")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Reconnaissance (Recce)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("24 x F-4E Phantom II")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighter Ground Attack (FGA)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("24 x Mirage M-2000E")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("150 x F-16C/D Fighting Falcon")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("30 x F-4E Phantom II")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("40 x A-7H Corsair II")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Airborne Early Warning (AEW)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x EMB-145H Erieye")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport (TPT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("15 x C-130B/H Hercules")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9 x Dornier 28")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x Gulfstream")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x C-27J Spartan")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Training (Trg)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10 x T-2C Buckeye")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("30 x T-2E Buckeye")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("20 x T-41D Mescalero")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("40 x T-6A/B Texan")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("10 x AS-332 Super Puma (transport)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("4 x AB-212 (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("13 x AB-205 (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("3 x Agusta A109 (Casevac)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("7 x Bell 47G (training)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Air launched missiles (ALM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("AGM-88 Harm ARM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("AMRAAM AAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Sidewinder AAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("MICA AAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Super R 530 AAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Maverick ASM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Scalp ASM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("AM-40 Exocet ASSM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Surface to Air Missiles (SAM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("9 x Crotale SAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("36 x Patriot SAM launchers")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("5 x SA-15 SAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("36 x MIM-14 Nike Hercules")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("12 x SA-300 Grumble launchers (stationed in Crete)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Some 35 mm guns")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CURRENT UNIT DEPLOYMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("(over platoon strength – 30 personnel. These are approximate figures)")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "34.87%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "65.13%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (ISAF) Afghanistan")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 150")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (KFOR) Kosovo")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 550")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EUFOR Bosnia")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 45")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("UNIFIL Lebanon")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 50")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Cyprus")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 1,100 (includes army detachment and personnel seconded to the Greek Cypriot National Guard)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NATO Headquarters")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The following major NATO headquarters is situated in Greece:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Combined Air Operations Centre – Larissa:")])])])]), _c('a', {
    attrs: {
      "id": "title76"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title76"
    }
  }), _c('a', {
    attrs: {
      "id": "title77"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("HUNGARY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("HUNGARY – BASIC FACTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "35.71%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "64.29%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10 million")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence budget 2010:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 1.3 billion (US$1.58 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GDP 2009:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 113 billion (US$137 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land area:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("93,030 sq kms (35,918 sq miles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Capital:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Budapest (Population 1.75 million)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Life expectancy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("72 years")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population growth rate:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("-0.25 per cent")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Total Armed Forces")])]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10,900 (plus approximately 30,000 reservists)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Maritime Wing:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Approximately 60")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Force:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5,600 (plus approximately 8,000 reservists)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Joint:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8,500")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Border Guards:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("11,000")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Conscription ended in November 2004.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MINISTRY OF DEFENCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contact Details")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Ministry of Defence")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Honvedelmi Miniszterium")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Balaton u 7/11")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("H-1055 Budapest")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("HUNGARY")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Tel: +36 1 132 25 00")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Fax: +36 1 111 02 42")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In 2007 a unified command structure was established with a Joint Forces Command responsible for commanding and coordinating all military operations.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ARMY (Land Forces)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army Strength")]), _vm._v(": 10,900 (plus approximately 30,000 reservists)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In general terms and available for immediate operations are:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("6 x Infantry Battalions")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Reconnaissance Battalion (Special Forces)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Armoured Battalion")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("3 x Engineer Battalions")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x NBC Battalion")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Artillery Battalions")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("3 x Logistic Battalions")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("3 x Military Police Battalions")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Outline Structure")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Military Operations are controlled by Land Force Headquarters in Budapest. The outline command organisation is as follows:")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0143.jpg",
      "src": "images/e9781783032051_i0143.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) 34 Reconnaissance Regiment operates in a Special Forces role and is assigned to the NATO Response Force.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) The majority of armoured units are in 25 Light Infantry Brigade which is assigned to the NATO Allied Rapid Reaction Corps.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(3) 5 Light Infantry Brigade specialises in peace support operations (PSO).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(4) 1 x Infantry Battalion is permanently assigned to the Multinational Land Force (MLF). With contributions from Italy, Slovenia and Hungary the MLF consists of a light infantry brigade at high readiness. MLF HQ is at Udine in Italy.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(5) Training Command has assets such as the Bakony Combat Training Centre.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Hungary – Army – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "47.40%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "52.60%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Main Battle Tanks (MBT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("120 x T-72 (about 30 in active units)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Reconnaissance (Recce)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("48 x BRDM (Wheeled – 19 active in NBC defence role)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Armoured Infantry Fighting Vehicles (AIFV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("150 x BTR-80A (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Some BMP 1 (Tracked – 487 in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("3 x MRAP Cougar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Armoured Personnel Carrier (APC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("150 x BTR-80 (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Self Propelled Artillery (SP Arty)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("150 x 122 mm 2S1 (in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Towed Artillery (Towed Arty)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("308 x 152 mm D-20 (20 in active units)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Mortars (Mor)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("96 x 120 mm (in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("50 x 82 mm")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Anti-Tank (Atk)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("100 x AT-5")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("140 x AT-4 (60 in active units)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("AIR AND AIR DEFENCE FORCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Air Force Strength")]), _vm._v(": approximately 5,600 (including about 8,000 reservists).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Outline structure")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "78%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0146.jpg",
      "src": "images/e9781783032051_i0146.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) 59 Air Base operates Mig-29, An-26 and L-39")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) Papa Air Base hosts the JAS 39 Grippen")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(3) Szolnok operates an attack helicopter squadron plus a transport helicopter squadron and a Yak-52 training squadron.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Hungary – Air Force – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "36.20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "63.80%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighter/Interceptor (Ftr)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9 x Mig-29B Fulcrum")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Mig-29UB")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighter Ground Attack (FGA)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("14 x JAS 39 Grippen (2 x D, 12 x C)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport (Tpt)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x AN-26 Curl (Modernised)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Training (Trg)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x L-39 Albatros")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9 x Yak-52")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("15 x Mi-24 Hind D/V (Attack) Being modernised")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("15 x Mi-8/17 (Transport) estimate in service (from an inventory total of 37)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air launched missiles (ALM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AA-10 Alamo (AAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AA-11 Archer (AAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AIM-9 Sidewinder (AAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AMRAAM on order (AAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x AT-6 ATGM (with Mi-24)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AGM-65 Maverick (ASM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Low Level Air Defence (LLAD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("45 x Mistral SAM launchers")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x SA-6 Gainful SAM launchers")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("50 x SA-18 Igla SAM (reported and may be in store)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NAVY (HUNGARIAN MARITIME WING)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Maritime Service Strength")]), _vm._v(": approximately 60.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Principal units:")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("3 x Nestin Class River Minesweepers")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("40 x Small River Patrol boats")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Under command of the Land Forces this extremely small Maritime Service concentrates on patrolling about 420 kms of the River Danube. These units are under the command of 1 Explosive Ordnance Disposal and Patrol Vessel Company.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("JOINT COMMAND")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The 8,500 personnel in units under Joint Command serve in the following:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Hazardous Material Supply Centre")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Logistics Supply Centre")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Aircraft Repair Plant")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Military Transport Centre")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Joint Support Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Central Medical Facility")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Central Training Base")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("NCO Training School")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Psychological Operations Centre")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("NBC Information Centre")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CURRENT UNIT DEPLOYMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("(over platoon strength – 30 personnel. These are approximate figures)")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "65.26%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "34.74%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (ISAF) Afghanistan")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 370")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (KFOR) Kosovo")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 275")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EUFOR Bosnia")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 150")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("UNFICYP Cyprus")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 90")])])])])])])]), _c('a', {
    attrs: {
      "id": "title77"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title77"
    }
  }), _c('a', {
    attrs: {
      "id": "title78"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("IRELAND")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("IRELAND – BASIC FACTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "39.78%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "60.22%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 million")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence budget 2010:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 694 million (US$846 million)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GDP 2009:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 166 billion (US$203 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land area:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("68,900 sq kms (26,500 sq miles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Capital:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Dublin (Population 1.2 million)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Life expectancy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("77 years")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population growth rate:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("0.8 per cent")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Total Armed Forces")])]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8,500 (with about 14,000 reservists)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Naval Service:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1,100 (with about 300 reservists)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Corps:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("800 (with about 100 reservists)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MINISTRY OF DEFENCE")])]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contact Details")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Department of Defence")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Parkgate")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Dublin 7")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("IRELAND")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Tel: +353 1 8042000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fax: +353 1 8045000")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ARMY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army Strength")]), _vm._v(": approximately 8,500 professionals and 14,000 reservists (total 22,500)\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("3 x Infantry Brigades")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Army Ranger Wing (ARW)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Air Defence Battery")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Logistic Support Group")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army Commands")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Military Operations are controlled by Army Headquarters in Dublin through the following headquarters:")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "72%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0150.jpg",
      "src": "images/e9781783032051_i0150.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note: Although under command of the army on a day-to-day basis, for operations, the ARW is usually tasked and under the direct command of the Deputy Chief of Staff (Operations) at Defence Forces HQ. The ARW consists of about 100 highly trained specialists. Irish Infantrv Brigade Outline Organisation")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Irish Infantry Brigade Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "67%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0151.jpg",
      "src": "images/e9781783032051_i0151.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Reserves")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In support of the Permanent Defence Force the 14,000 personnel of the Army Reserves (FCA) are organised into the ‘Integrated Reserve’ and the ‘Non Integrated Reserve’:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Integrated Reserve – 9 x Infantry Battalions, 3 x Armoured Troops and 3 x Field Artillery Batteries.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Non Integrated Reserves – 3 x Infantry Brigades with 31 x Infantry Companies and associated ‘teeth’ and ‘support’ units.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ireland – Army – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "44.53%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "55.47%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Light Tanks (Lt Tk)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("14 x Scorpion (Tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Reconnaissance (Recce)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("18 x AML-20 (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("15 x AML-90 (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Armoured Personnel Carrier (APC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("2 x XA-180 Sisu (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("80 x Pirhana III (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("27 x MRAP Cougar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Towed Artillery (Towed)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("24 x 105 mm Light Gun")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("30 x 88 mm 25 pounder (estimate in service for training)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Mortars (Mor)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("60 x 120 mm (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("300 x 81 mm (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("100 x 60 mm (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Anti-Tank (Atk)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("36 x Javelin")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("20 x Milan (possibly in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("400 x 84 mm Carl Gustav")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Low Level Air Defence (LLAD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("7 x RBS-70 SAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("35 x 40 mm L/70 (gun system)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NAVY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Irish Naval Service Strength")]), _vm._v(": approximately 1,100 (with about 300 reservists).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Principal units:")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("8 x Offshore and Coastal Patrol Vessels")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Irish Naval Service (INS) Outline")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The majority of the INS’s activities are directed at fishery protection and patrolling the Irish Economic Zone. The INS has its Headquarters and Naval Base on Haulbowline Island, in the area of Cork Harbour. The Naval Base includes the National Surveillance Centre, which assists in coordinating fishery surveillance activities.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The 300 x naval reservists are organised into 5 x companies trained for port security duties and costal defence.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ireland – Navy – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "39.88%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "60.12%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Offshore Patrol Vessels (OPV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x P31 Eithne Class (with helipad) Patrol Vessel")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Rosin Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Deirdre P21 Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Peacock Class")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("AIR CORPS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Air Corps Strength")]), _vm._v(": approximately 800 (with about 100 reservists).")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Irish Air Corps Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "68%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0155.jpg",
      "src": "images/e9781783032051_i0155.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Corps is one of the smallest European Air Forces and has no attack aircraft. The majority of aviation missions are related to surveillance and reconnaissance tasks in support of the army, police and naval service.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ireland – Air Corps – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "37.54%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "62.46%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Maritime Patrol (MP)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x CASA 235")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport (Tpt)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Learjet 45")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Gulfstream IV")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Beech 200 Super King Air")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("General Duties (GD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x Cessna FR-172 (monitoring cash in transit)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x BN Defender 4000 (Garda support)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Training/Light Strike (Trg)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("7 x PC-9M")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x AW 139 (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x EC-135 (utility and light attack)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x EC-135T/P2 (Garda support and training)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CURRENT UNIT DEPLOYMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("(over platoon strength – 30 personnel. These are approximate figures)")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "56.50%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "43.50%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EUFOR CAR/Chad")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 430")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EUFOR Bosnia")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 43")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("KFOR Kosovo")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 230")])])])])])])]), _c('a', {
    attrs: {
      "id": "title78"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title78"
    }
  }), _c('a', {
    attrs: {
      "id": "title79"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ITALY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ITALY – BASIC FACTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "42.11%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "57.89%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("58 million")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence budget 2010:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 15.5 billion (US$18.9 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GDP 2009:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 1,510 billion (US$1,842 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land area:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("301,338 sq kms (116,346 sq miles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Capital:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Rome (Population 2.7 million)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Life expectancy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("80.5 years")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population growth rate:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("0.13 per cent")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Total Armed Forces")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "64.88%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "35.12%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("104,000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Navy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("34,000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Force:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("44,000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Caribinieri:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("107,000:")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Reserves: About 40,000 ready reserves the majority of which are assigned to the army.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Conscription was abolished in 2004.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MINISTRY OF DEFENCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contact Details")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Ministero of Defence")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Palazzo Baracchini")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Via XX Settembre 8 – 00187 Rom3")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ITALY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ITALIAN ARMY")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Land Force Headquarters")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("3 x Operational Commands")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("3 x Regional Headquarters")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("11 x Operational Brigades")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("5 x Support Brigades")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The following diagram shows the current outline structure of the Italian Army:")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "75%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0160.jpg",
      "src": "images/e9781783032051_i0160.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes: (1) This is the NATO headquarters for a Rapidly Deployable Corps (RDC) operating under the direct command of the NATO Supreme Allied Commander Europe (SACEUR). There are 5 x NATO RDC and in any emergency various NATO nations would assign troops to these RDC as required.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) There are 5 x brigades providing support to HQ Land Forces Command: Air Defence Brigade (Padua); Engineer Brigade (Udine); Logistics Brigade (Treviso); Signal Brigade (Anzio); ISTAR Brigade (Anzio).")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "63%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0161.jpg",
      "src": "images/e9781783032051_i0161.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note: This formation has the ability to produce a divisional sized headquarters should the need arise.")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0162.jpg",
      "src": "images/e9781783032051_i0162.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note: This formation has the ability to produce a divisional sized headquarters should the need arise. Bersaglieri units are generally highly mobile light infantry formations.")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "67%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0163.jpg",
      "src": "images/e9781783032051_i0163.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note: (1) Command troops include 4 Alpini (Parachute) Regiment (Bolzano) and 6 Alpine Regiment (San Candido).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Once again this formation has the ability to produce a divisional sized headquarters should the need arise.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Italian Army – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "38.92%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "61.08%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Main Battle Tanks (MBT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("200 x Ariete")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("120 x Leopard 1A5 (in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Reconnaissance (Recce)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("300 x B-1 Centauro (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Infantry Fighting Vehicles (AIFV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("200 x Dardo (tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("60 x VBM Freccia (total of 249 planned)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Personnel Carrier (APC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("540 x Puma (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1,000 x VCC-1/VCC-2 (estimate in service – M-113 type)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("250 x M-113 (estimate – remaining in service)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("200 x Bv-206 (tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1,260 VTLM Lince (wheeled – FCLV)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Self Propelled Artillery (SP Arty)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("70 x 155 mm PzH 2000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("90 x 155 mm (many in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Towed Artillery (Towed)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("160 x 155 mm FH-70")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Multiple Rocket Launcher (MRL)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("22 x 227 mm MLRS")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mortars (Mor)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("200 x 120 mm")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("200 x 81 mm")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Anti-Tank (Atk)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("250 x I-TOW (ATGW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1000 x Milan (ATGW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Some Spike reported")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("400 x 80 mm Folgore RL (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2,000 x 110 mm Pzf-3 (RL)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Low Level Air Defence (LLAD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("36 x MIM-23 Hawk (SAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("32 x SPADA 2000 (SAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("60 x Stinger (MANPAD)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army Aviation")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("60 x A129 Mangusta (attack)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("20 x CH-47C (transport – being replaced by 16 x CH-47F)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10 x TTH NH-90 (transport – 30 more on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("21 x Bell-412 (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("40 x AB-205 (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("40 x AB-206 (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Do-228 (fixed wing transport)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x P180 (fixed wing transport)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ITALIAN NAVY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Navy Strength")]), _vm._v(": approximately 34,000.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Principal units:")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("6 x Submarines")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Aircraft Carriers")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("12 x Destroyers and Frigates operational")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("14 x Patrol Vessels")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Italian Navy Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0165.jpg",
      "src": "images/e9781783032051_i0165.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note: (1) The Amphibious Forces includes the 1,300 personnel of the San Marco Regiment. This unit includes 1 x Assault Battalion, 1 x Logistic Support Battalion; 1 x Special Forces Company; 1 x Operations Company (for marine detachments on naval vessels).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Italian Navy – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "45.91%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "54.09%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Submarines Tactical (SSK)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Sauro")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Tadaro (Type 212A – 2 more on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Aircraft Carriers (CV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Garibaldi")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Cavour")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Destroyers (DG)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Andrea Doria")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Lugi Durand de la Penne")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Frigates (FF)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x Maestrale")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Artigliere")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x FREMM on order (deliveries start in 2014)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Amphibious (Amphib)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x San Georgio (LPD – 350 troops)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x San Giusto (LPD – 350 troops)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("15 x Landing Craft (various types)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Corvettes (FS)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x Minerva")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mine Countermeasures (MCM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Ponza (minehunter)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x Lerci (minehunter)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Patrol and Coastal Combatants (PCC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x Cassiopea (helicopter capability)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x Commandante (helicopter capability)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Esploratore")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Miscellaneous")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Replenishment Vessels")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Oil Tankers")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Water Tankers")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x Vehicle Transports")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x EW Vessel")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Training Vessels")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Submarine and Rescue Vessel")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Naval Aviation")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("30 x AB-212 (ASW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x EH 101 (ASW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x EH 101 (AEW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x EH 101 (support)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("56 x NHI NH 90 (support – on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("15 x AV-8B Harrier II (fixed wing)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("2 x TAV-8 Harrier (training – fixed wing)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("22 x F-35B (on order to replace Harrier)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ITALIAN AIR FORCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Air Force Strength")]), _vm._v(": 44,000.\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("5 x Fighter Squadrons")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Fighter Ground Attack Squadrons")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Transport Squadrons")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Maritime Reconnaissance Squadron")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("4 x Training Squadrons")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Italian Air Force Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "68%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0168.jpg",
      "src": "images/e9781783032051_i0168.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Operational Forces Command – Detailed Listing")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "32.24%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "24.04%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "43.72%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Combat Forces Command")])]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Naples")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 Wing")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Rivolto")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Spada SAM Systems")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 Wing")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Grosetto")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Eurofighter Typhoon")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 Wing")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Cervia")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("F-16ADF")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 Wing")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Ghedi")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Tornado IDS")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("32 Wing")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Amendola")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AMX FGA & Predator UAV")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("36 Wing")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Gioia")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Eurofighter Typhoon")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("37 Wing")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Trapani")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("F-16ADF")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("50 Wing")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Piacenza")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Tornado ECR")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("51 Wing")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Istrana")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AMX FGA")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("313 Aerobatic Squadron")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Rivolto")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("MB339 (Frecce Tricolori)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("1st Special Air Brigade")])]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Padua")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9 Wing")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Grazzanise")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AB 212")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("16 Wing")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Martina Franca")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Security Battalion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("17 Wing")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Cerveteri")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Special Forces Group")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("46 Air Brigade")])]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Pisa")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport Squadrons")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Pisa")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("C-130J and C-27J")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("14 Wing")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Practica de Mare")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Boeing KC-767, G.222RM/VS,")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("P180, P166, MB-399A")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("15 Wing")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Stefano Cagna")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AB-212, HH-3F SAR")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("31 Wing")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Ciampino")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Airbus A319, Falcon 50 and SH-3D")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("41 Wing")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Sigonella")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Breguet Atlantic MR")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Italian Air Force – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "55.41%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "44.59%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighters (FTR)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("22 x F-16A/B (on lease from USAF)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("45 x Typhoon (76 more on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighter Ground Attack (FGA)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("70 x Tornado IDS")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("66 x AMX")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Suppression of Enemy Air Defence (SEAD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("16 x Tornado ECR")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport (Tpt)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("21 x C-130J")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10 x C-27J")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x KC-767 (tanker)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x A319 Airbus")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("7 x Falcon 50/900")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("15 x P.180")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Maritime Patrol (MP)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x Atlantic")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Training (Trg)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("80 x MB-339")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("30 x SF 260EA")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("20 x AMX-T")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("48 x NH 500E (training and utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("30 x AB-212AM (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x HH-3F (SAR)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air launched missiles (ALM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AMRAAM (AAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Sidewinder (AAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Iris-T (AAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("SCALP EG (ASM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Storm Shadow (ASM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("HARM (ARM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Surface to Air Missiles (SAM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("SPADA (towed)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Unmanned Air Vehicles (UAV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x Predator RQ- 1A")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x MQ-9 Reaper")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Carabinieri")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Strength")]), _vm._v(": 107,000")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Carabinieri is a branch of the armed forces under the command of the Ministry of Defence. The force is organised on a territorial basis for law enforcement missions and criminal investigation. There are 19 x regional commands and 102 x provincial commands which account for about 80 percent of the total force personnel. Specialist units include:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Mobile Unit Command:")]), _vm._v(" this consists of two brigades configured to assist in national defence and take part in overseas operations in support of the Armed Forces. This command has a major reinforcement input into areas where the local Italian police are unable to cope during an emergency or crisis.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ROS:")]), _vm._v(" This is the special operations group which deals with terrorism and the more sophisticated types of organised crime.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Cuirassiers: Are an elite group within the Carabinieri who guard the President of Italy.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CURRENT UNIT DEPLOYMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("(over platoon strength – 30 personnel. These are approximate figures)")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "67.18%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "32.82%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (ISAF) Afghanistan")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 3,300")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (KFOR) Kosovo")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 1,450")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EUFOR Bosnia")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 300")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("UNIFIL – Lebanon")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 2,500")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NATO Headquarters")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The following major NATO headquarters are situated in Italy:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("HQ Joint Force Command – Naples")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Joint Force Component Command Maritime – Naples")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Combined Air Operations Centre – Poggio")])])])])]), _c('a', {
    attrs: {
      "id": "title79"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title79"
    }
  }), _c('a', {
    attrs: {
      "id": "title80"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("LATVIA")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("LATVIA – BASIC FACTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "26.88%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "73.12%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2.3 million")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence budget 2008:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 189 million (US$230 million)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GDP 2009:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 18.5 billion (US$22.5 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land area:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("62,100 sq kms (23,885 sq miles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Capital:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Riga (Population 750,000)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Life expectancy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("71 years")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population growth rate:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("0.9 per cent")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Total Armed Forces")])]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1,500 (plus 11,000 reservists – mainly National Guard)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Navy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("550")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Force:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("300")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Joint Forces/Staff")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3,000 in various joint functions such as command, administration, support and training (includes about 650 conscripts).")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Conscription is currently 12 months and there is an aspiration to move to a professional force in the near future.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("On mobilisation the 5,000 personnel of the Border Guard (normally commanded by the Ministry of the Interior) would become a Ministry of Defence asset.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MINISTRY OF DEFENCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contact Details")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Press and Public Information Office")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Ministry of Defence")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("K. Valdemara 10/12")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("LV-1473 Riga")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("LATVIA")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Tel: +371 721 0419")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Fax: +371 724 3115")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("LATVIAN ARMY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army Strength")]), _vm._v(": approximately 1,500 (plus about 11,000 reservists – mainly National Guard).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In general terms and available for immediate operations are:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Infantry Battalions")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Land Forces (LF) consists of a regular and reserve component. The regular component consists of a LF Brigade and 2 x infantry battalions. The reserve component is based on the National Guard which is organised on a regional basis. National Guard battalion headquarters act as mobilisation centres for the Guard’s specialised artillery battalion, engineer battalion, air defence battalion and NBC defence battalion.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Latvian LF Outline Structure")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "78%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0173.jpg",
      "src": "images/e9781783032051_i0173.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) The majority of the active duty (regular and conscript personnel) are in the 2 x Infantry Battalions. National Guard soldiers provide the vast majority of the persormel in other units.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) Latvia provides a small contingent (one military police platoon and/or one explosive ordnance disposal unit) to the EU’s Polish, Germany, Slovakia, Latvia Battlegroup.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(3) The Nation Guard provide 13 x infantry battalions, 1 x artillery battalion, 1 x engineer battalion, 1 x air defence Ioattalion and 1 x NBC defence battalion.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Latvian Army – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "47.84%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "52.16%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Reconnaissance (Recce)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x BRDM-2 (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Towed Artillery (Towed)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("24 x 100 mm K-53")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mortars (Mor)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("50 x 120 mm")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10 x 82 mm")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("40 x 60 mm")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Anti-Tank (Atk)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x 84 mm Carl Gustav (RL)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("400 x AT-4 (ATGW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("400 x RPG-7 (RL)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Low Level Air Defence (LLAD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x SA-7 (SAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("About 50 guns of various types")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("LATVIAN NAVY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Navy Strength")]), _vm._v(": approximately 500 (including 200 conscripts)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Principal units:")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("4 x Patrol Craft")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("6 x Mine Countermeasures Vessels")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Latvian Navy Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "65%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0175.jpg",
      "src": "images/e9781783032051_i0175.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note: (1) The Sea Surveillance Group has the responsibility for the maritime regions of Liepaja, Ventspilis and Riga. In addition, this group is responsible for naval communications.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Latvian Navy – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "38.35%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "61.65%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Patrol Craft (PC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Storm Class (Fast patrol boat)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Valpas (Patrol craft offshore)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5-6 small patrol craft for Coast Guard tasks")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mine Countermeasures Vessels")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("(MCMV) 4 x Alkmaar minehunters")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Namejs Class minehunter")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Kondor minesweepers")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Miscellaneous")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Vidar Class staff and support vessel")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x hydrographic vessel")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9 x Coast Guard launches")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("LATVIAN AIR FORCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Air Force Strength")]), _vm._v(": approximately 300 personnel")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Latvia has no combat aircraft and the air defence of Latvian airspace is the responsibility of the NATO Baltic Air Policing element which operates from Lithuania.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Outline structure")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "62%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0177.jpg",
      "src": "images/e9781783032051_i0177.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) Logistic and maintenance support is provided by the Joint Force Support Command.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Latvia is part of the Baltic airspace surveillance network (BALTNET) which is a NATO regional organisation for airspace command and control. BALTNET has a Regional Air Surveillance and Coordination Centre (RASCC) at Kaarmelava, Lithuania with National Nodes in Latvia, Lithuania and Estonia.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Latvian Air Force – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "54.04%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "45.96%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport (TPT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x An-2 Colt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x L-410")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Mi-2 Hoplite")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Mi-8 Hip")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x A-109")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Training (Trg)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Wilga-35A")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Defence")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("18 x 40 mm L/70")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("RBS-70 on order")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CURRENT UNIT DEPLOYMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("(over platoon strength – 30 personnel. These are approximate figures)")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("NATO (ISAF) Afghanistan")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("- 160")])])])])])])]), _c('a', {
    attrs: {
      "id": "title80"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title80"
    }
  }), _c('a', {
    attrs: {
      "id": "title81"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("LITHUANIA")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("LITHUANIA – BASIC FACTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "40.51%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "59.49%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3.5 million")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence budget 2010:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 241 million (US$294 million)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GDP 2009:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 27 billion (US$39 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land area:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("64,800 sq kms (24,923 sq miles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Capital:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Vilnius (Population 540,000)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Life expectancy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("72 years")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population growth rate:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("0.2 per cent")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Total Armed Forces")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "28.50%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "71.50%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army (Land Forces):")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("7,000 including about 4,500 active reserves (NDVF) and 200 – 300 conscripts")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Navy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("400 including about 100 conscripts")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Force:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1,000 including about 150 conscripts")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Joint Logistics Command:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1,200 including about 150 conscripts")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("TRADOC:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1,300 including about 300 conscripts (Training and Doctrine Command)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Conscripts generally serve for 12 months and there is a longer term plan to abolish conscription by 2014.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MINISTRY OF DEFENCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Special Forces Group which consists of a counter terrorist element, a marine element and a Jaeger Battalion "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("zz")]), _vm._v("(-) are under the direct command of the Ministry of Defence.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("On mobilisation both the Border Guard and the Special Police, normally under the command of the Ministry of the Interior become Ministry of Defence assets.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Land Forces Commander is the Deputy Commander of the Armed Forces.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("National Defence Voluntary Forces (NDVF) are under direct command of the Land Forces.\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contact Details")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Ministry of Defence")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Totoriu 25/3")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2600 Vilnius")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("LITHUANIA")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Tel: +370 2 624821")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Fax: +370 2 226082")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("LITHUANIAN LAND FORCES")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Land Forces Strength")]), _vm._v(": approximately 7,000 including about 200-300 conscripts and 4,500 active reserves from the NDVF.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In general terms and available for immediate operations are:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Motorised Infantry Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("3 x Independent Battalions")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The following diagram shows the outline structure of the Lithuanian Land Forces")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "63%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0182.jpg",
      "src": "images/e9781783032051_i0182.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) Lithuania is prepared to provide 1 x motorised infantry battalion (plus support elements) for international or alliance peace support operations.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) The country provides a contingent to the Polish led battlegroup in company with other contingents from Germany, Slovakia and Latvia.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Iron Wolf Motorised Infantry Brigade")]), _vm._v(" are as follows:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("King Mindaugas Motorised Infantry Battalion")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Lithuanian Grand Duke Algirdas Motorised Infantry Battalion")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Grand Duchess Birute Motorised Infantry Battalion")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Lithuanian Grand Duke Kaestutis Motorised Infantry battalion")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("General Romualdas Artillery Battalion")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Duke Vaidotsas Forward Support Battalion")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Reconnaissance Company")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Independent Units")]), _vm._v(" are as follows:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Jaegar Battalion (Special Forces Group)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Juozas Vitkus Engineer Battalion")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Lithuanian Grand Duke Gediminas Staff Battalion")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("National Defence Voluntary Force")]), _vm._v(" units are as follows:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1st Territorial Unit NDVF (Dainava MD) Alytus")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2nd Territorial Unit NDVF (Darius and Girenas MD) Kaunas")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("3rd Territorial Unit NDVF (Pemaieiai MD) Klaipeda")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("5th Territorial Unit NDVF (Vytis MD) Panevebys")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("6th Territorial Unit NDVF (Prisikelimas MD) Siauliai")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("8th Territorial Unit NDVF (Didbioji Kova MD) Vilnius")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Aviation Unit NDVF, Vilnius")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Butigeidis Dragoon Training Battalion NDVF")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The above units total some 150 defence companies.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Expect the NDVF to have a total of about 4,500 personnel.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Lithuanian Land Forces – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "38.29%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "61.71%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Reconnaissance (Recce)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("11 x BRDM 2 (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Personnel Carrier(APC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x M-113 (Tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("22 x BTR-60 (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x Bv 206 (estimate in service)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("35 x HMMWV (various types and some with Javelin ATGW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Towed Artillery (Towed)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("24 x 105 mm M-101 (estimate in service)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mortars (Mor)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x 120 mm (estimate in service)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("40 x 82 mm ((estimate in service)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Anti-Tank (Atk)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("30 x Javelin ATGW (estimate of launchers in service)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("250 x 84 mm Carl Gustav RL (estimate in service)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("400 x 90 mm PV-1110 RL")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("400 x RPG-7 RL (estimate in service)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Low Level Air Defence (LLAD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x Stinger (SAM)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("LITHUANIAN NAVY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Navy Strength")]), _vm._v(": approximately 400 including about 100 conscripts")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Principal units:")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Frigate")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("4 x Patrol Vessels")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Mine Warfare Vessels")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Lithuanian Navy Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "63%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0184.jpg",
      "src": "images/e9781783032051_i0184.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) The main naval base is at Klaipeda.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Lithuanian Navy – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "39.95%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "60.05%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Frigates (FF)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Grisha III (light frigate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Patrol Craft (PC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Storm")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x SF 300 (ex Danish Flyvefisken – 1 more on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mine Countermeasures Vessels (MCMV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Suduvis (coastal mine hunters)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Miscellaneous")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Vidar (logistics, support & research vessel)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x harbour tugs/cutters")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("LITHUANIAN AIR FORCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Air Force Strength")]), _vm._v(": approximately 1,000 including about 150 conscripts.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Outline structure")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "64%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0186.jpg",
      "src": "images/e9781783032051_i0186.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) Lithuania is part of the Baltic airspace surveillance network (BALTNET) which is a NATO regional organisation for airspace command and control. BALTNET has a Regional Air Surveillance and Coordination Centre (RASCC) at Kaarmelava. Lithuania with National Nodes in Latvia and Estonia.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) Lithuania has no combat aircraft and the air defence of Lithuanian airspace is the responsiloility of the NATO Baltic Air Policing element.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Lithuanian Air Force – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "43.35%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "56.65%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport (TPT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x C-27J Spartan")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x An-26RV")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x L-410")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Training (Trg)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x L-39ZA Albatros")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x L-39C (probably inactive)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Mi-8MTV")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x Mi-8T")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Mi-8PS")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Low Level Air Defence")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("18 x 40 mm L/70 (AAA)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("21 x RBS-70 SAM (with Giraffe FCS)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("National Defence Voluntary Forces")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "39.02%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "60.98%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport (TPT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x An-2")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Utility")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Piper PA-38 Tomahawk")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x PZL-104 Wilga")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Yak-18T")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Training")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("24 x Yak-52")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("JOINT LOGISTICS COMMAND")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1,200 (including about 150 conscripts) manning the following units:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Logistic Support Battalion")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Joint Medical Services")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Equipment Department")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Depot Services")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Movement Control Centre")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Mapping Centre")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Garrison Support Services")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("TRAINING AND DOCTRINE COMMAND (TRADOC)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1,300 (including about 300 conscripts) supporting the following:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Elementary Training Regiment")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Non-Commissioned Officer School")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Central Training Area")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Combined Warfare Training Centre")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CURRENT UNIT DEPLOYMENTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "67.15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "32.85%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (ISAF) Afghanistan")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 250")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (KFOR) Kosovo")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 35")])])])])])])]), _c('a', {
    attrs: {
      "id": "title81"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title81"
    }
  }), _c('a', {
    attrs: {
      "id": "title82"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("LUXEMBOURG")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("LUXEMBOURG – BASIC FACTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "39.22%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "60.78%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("483,000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence budget 2010:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 190 million (US$231 million)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GDP 2009:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 39 billion (US$46 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land area:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2,586 sq kms (994.6 sq miles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Capital:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Luxembourg (Population 79,000)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Life expectancy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("78 years")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population growth rate:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1.3 per cent")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Total Armed Forces")])]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("900")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Gendarmerie")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("600")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MINISTRY OF DEFENCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contact Details")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Ministry of Defence")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Plateau du St Esprit")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("L-2915 Luxembourg")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("LUXEMBOURG")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Tel: +352 478 2806")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Fax: +352 462 682")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chain of Command")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "54%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0191.jpg",
      "src": "images/e9781783032051_i0191.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) Police personnel strength is approximately 460.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) There is no Navy and no Air Force although for Iegal purposes, the 17 x E-3A Sentry aircraft of the NATO Airborne Early Warning Force are registered in Luxembourg as are the 3 x Boeing 707 TCA.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(3) Luxembourg provides a small contingent to the EU French-German Battlegroup. Other contributors are Spain and Belgium.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("LUXEMBOURG ARMY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army Strength")]), _vm._v(": approximately 900 including 40 x officers, 125 NCOs and about 100 civilians.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Outline Structure")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "57%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0192.jpg",
      "src": "images/e9781783032051_i0192.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Light Infantry Battalion consists of the following company groups:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Luxembourg Eurocorps Reconnaissance Company")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This Company provides the Luxembourg contingent to the Eurocorps and is generally under the command of the Belgian Land Component with:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 × reconnaissance platoons")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 × anti-tank platoon")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 × forward air control team")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 × logistic support platoon")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Luxembourg NATO Reconnaissance Company")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This company provides the Luxembourg contingent to the NATO pool of deployable forces with:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 × reconnaissance platoons")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 × anti-tank platoon")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 × forward air control team")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 × logistic support platoon")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Headquarters Company")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Providing administrative and logistic support across the whole battalion structure.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Military Training Centre has an Education and Instruction Company that provides both basic training and educational courses for military career advancement.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Luxembourg Army – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "40.54%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "59.46%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Reconnaissance (Recce)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("24 x M 1114 (HMMWV) Enhanced Capability Vehicle")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Personnel Carrier (APC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x Commando (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mortars (Mor)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x 81 mm (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Anti-Tank (Atk)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x TOW ATGW")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x 66 mm M72 LAW (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Low Level Air Defence (LLAD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x 12.7 mm MG (estimate)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CURRENT UNIT DEPLOYMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("(over platoon strength – 30 personnel. These are approximate figures)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("None over platoon strength but some personnel are deployed as follows:")])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "64.10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "35.90%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (ISAF) Afghanistan")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 9")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (KFOR) Kosovo")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 25")])])])])])])]), _c('a', {
    attrs: {
      "id": "title82"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title82"
    }
  }), _c('a', {
    attrs: {
      "id": "title83"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MALTA")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MALTA – BASIC FACTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "42.41%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "57.59%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("407,000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence budget 2010:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 42 million (US$60 million)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GDP 2009:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 7.4 billion (US$9 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land area:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("316 sq kms (121.5 sq miles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Capital:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Valetta (Population 10,000 city proper)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Life expectancy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("78 years")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Population growth rate:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("1 per cent")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Total Armed Forces")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Armed Forces of Malta: 2,000 (includes small maritime and aviation groups)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MINISTRY OF DEFENCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Armed Forces of Malta (AFM) – Chain of Command")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This is an extremely small single force organisation with 3 x regimental groups as follows:")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "61%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0197.jpg",
      "src": "images/e9781783032051_i0197.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note: (1) EVRF - Emergency Volunteer Reserve Force (about 100 personnel)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contact Details")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Armed Forces of Malta (AFM)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Headquarters")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Luqa Barracks")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("CMR 02 Luqa")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("MALTA")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Outline AFM Structure")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("No 1 Regiment (Infantry)")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "61%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0198.jpg",
      "src": "images/e9781783032051_i0198.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes: (1) A Company has the responsibility for the defence and security of Malta International Airport.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) B Company is responsible for the security of government buildings and vulnerable utilities.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(3) C Company provides the AFM QRA (Quick Reaction Force) for both domestic and EU wide operations.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(4) C Company administers and provides continuation training to the infantry element of the EVRF.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(5) D Company provides fire support and is equipped with anti-tank weapons, and machine guns.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("No 2 Regiment (Air and Maritime)")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "66%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0199.jpg",
      "src": "images/e9781783032051_i0199.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) This small Air Squadron operates 7 x fixed wing aircraft and 7 x helicopters and is responsible for Maltese airspace.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) The Maritime Squadron operates 7 x patrol vessels and has an important search and rescue role in this area of the Mediterranean.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(3) The Air Defence Battery is equipped with 40 mm L/70 guns and 14.5 mm machine guns. In addition, the Air Defence Battery administers and provides continuation training to the air defence element of the EVRF.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("No 3 Regiment (Support)")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "63%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0200.jpg",
      "src": "images/e9781783032051_i0200.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) All of the aloove sulo-units provide assistance to other Maltese Government agencies.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) EME - Electrical and Mechanical Engineer Squadron.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(3) The Explosives and Ammunition Company includes the Explosive Ordnance Disposal (EOD) platoon.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(4) The Training wing provides basic AFM training and some specialised courses.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Maltese Armed Forces – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "43.52%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "56.48%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Land:")])]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Anti-tank (Atk)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10 x RPG-7 RL (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Low Level Air Defence (LLAD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x 40 mm L/70 AAA and some 14.5 mm MG")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Air:")])]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport (Tpt)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x BN 2B Islander")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Training (Trg)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x Bulldog T1")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x Alouette III (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Hughes 500M (liaison)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Bell 47G (utility and training)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Maritime:")])]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Patrol Vessels (PC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Diciotti P61 (OPV)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Maritime Protector (PBC)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Bremse Class (PCI)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Swift Class (PCI)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Miscellaneous")])]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Landing Craft (LCVP)")])])])])])])]), _c('a', {
    attrs: {
      "id": "title83"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title83"
    }
  }), _c('a', {
    attrs: {
      "id": "title84"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NETHERLANDS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NETHERLANDS – BASIC FACTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "43.70%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "56.30%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("16.4 million")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence budget 2010:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 8.5 billion (US$10.8 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GDP 2009:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 576 billion (US$702 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land area:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("41,447 sq kms (16,002 sq miles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Capital:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("The Hague (Population 486,000)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Life expectancy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("79 years")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population growth rate:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("0.4 per cent")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Total Armed Forces")])]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("22,000 (plus about 3,000 reserves)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Navy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9,470 including 3,000 marines")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Force:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9,500 (plus about 400 reserves)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Military Constabulary:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5,900")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MINISTRY OF DEFENCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contact Details")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Ministry of Defence")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Plein 4, PO Box 20701,")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("NL-2500 ES The Hague")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Netherlands")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Tel: +31 70 318 81 88")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ROYAL NETHERLANDS ARMY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army Strength:")]), _vm._v(" Approximately 22,000 (with about 3,000 reserves)")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army Outline Structure")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("3 x Combat Brigades")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "59%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0203.jpg",
      "src": "images/e9781783032051_i0203.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note: There appear to be 5 x SF companies that include airborne, counter-terrorist and maritime capabilities.")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "66%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0204.jpg",
      "src": "images/e9781783032051_i0204.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Note:")]), _vm._v(" STAR – Surveillance, Target Acquisition and Reconnaissance Battalion; CIMIC – Civil-Military Co-operation.")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "68%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0205.jpg",
      "src": "images/e9781783032051_i0205.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Netherlands – Army – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "38.76%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "61.24%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Main Battle Tanks (MBT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("44 x Leopard 2A6 (possibly 60 available)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Reconnaissance (Recce)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("140 x Fennek (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Note :")]), _vm._v(" 438 x Fennek are in service in a variety of specialised battlefield roles.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x Fuchs (NBC Recce)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Infantry Fighting Vehicles")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("(AIFV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("184 x CV9035 (tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Personnel Carrier (APC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("200 x Boxer – on order replacing YPR-765 between 2010- 2016 (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("200 x YPR-765 (tracked – M113 type – being withdrawn)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("112 x Bushmaster (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("80 x Patria XA-188 Sisu (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Artillery (Arty)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("57 x 155 mm PzH 2000 (SP – available)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mortars (Mor)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("16 x 120 mm Brandt (towed)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("150 x 81 mm – many of these L16")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Anti-Tank (Atk)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("130 x MRAT (Fennek AFV with Spike ATGW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("167 x SPIKE launchers")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Approximately 900 Panzerfaust (RL)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Low Level Air Defence (LLAD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("18 x Stinger SAM (FIM-92A) on Fennek")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("18 x Stinger SAM (FIM-92A) MANPAD")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Unmanned Air Vehicle")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x EMT Aladin")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("32 x SAGEM Sperwer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Some IAI MALE reported")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ROYAL NETHERLANDS NAVY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Navy Strength:")]), _vm._v(" 9,470 including 3,000 marines")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Principal units:")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("4 x Submarines")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("6 x Destroyers and Frigates")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("10 x Mine Countermeasures Vessels")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Netherlands Navy Outline Organisation")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("There are naval bases at Den Helder and Texel with overseas base at Willemstad (Curacao). There are Marine barracks at Rotterdam, Doom, Suffisant and Curacao and Savanete (Netherlands Antillies).")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Netherlands Navy – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "38.17%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "61.83%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Submarines Tactical (SSK)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Walrus Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Destroyers (DD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Zeven Provincien Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Frigates (FF)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Karel Doorman")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mine Countermeasures (MCM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10 x Alkmaar (Tripartite type)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Amphibious Vessels (LPD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Rotterdam (carries helicopters, armoured vehicles and up to 600 troops)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Johan de Witt (carries helicopters, armoured vehicles and up to 620 troops)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("15 x assorted landing craft")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Miscellaneous")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Tankers")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Support Vessels")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Survey Vessels")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Training Ships")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("21 x SH-14D Lynx ASW (possibly 14 in service)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("20 x NH-90 (deliveries continue until 2013)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Marines (3,000 personnel)")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Marine Infantry Battalions (1 x Bn integrated with UK 3 Commando Brigade)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Amphibious Combat Support Battalion")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Amphibious Logistical Battalion")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Reorganisation continues and the size of the Marine Corps may be increased.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Equipment includes:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("74 x BVS10 Viking Personnel Carrier")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("20 x XA-188 Sisu APC")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("100 x BV206D Personnel Carrier")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("12 x 120 mm Brandt Mortars")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("32 x 81 mm Mortar")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("SPIKE ATGW")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Stinger SAM MANPAD")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NETHERLANDS AIR FORCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Air Force Strength")]), _vm._v(": 9,500 (plus about 400 reserves)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Netherlands Air Force Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0208.jpg",
      "src": "images/e9781783032051_i0208.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) Air defence training and support for all three armed services is provided at the De Peel Airbase.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) 11 Airmobile Brigade trains at Deelen Air Base.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(3) Eindhoven hosts the European Air Transport Coordination Centre")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Netherlands Air Force – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "42.28%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "57.72%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighter Ground Attack (FGA)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("87 x F-16AM/BM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport (Tpt)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x C-130 Hercules")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Fokker 50")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x MD DC-10")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Gulfstream IV")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air to Air Refuelling (AAR) 2 x KDC-10")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Training (Trg)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("13 x PC-7 Turbo Trainer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("30 x AH-62D Apache")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x SA-316 Alouette III (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("11 x CH-47D Chinook (6 more on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x AB-412 (SAR)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("16 x AS-532U2 Cougar (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("21 x Lynx (ASW/SAR) being replaced by 20 x NH-90")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air launched missiles (ALM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AMMRAM (AAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Sidewinder (AAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Hellfire (ASM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Maverick (ASM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Surface to Air Missiles (SAM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("32 x MIM-104 Patriot Launchers")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("250 x Stinger (MANPAD)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CURRENT UNIT DEPLOYMENTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("NATO (ISAF) Afghanistan")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("- 2,100")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("EUFOR Bosnia")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("- 70")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("There is a security and anti-smuggling detachment based at Aruba in the Netherlands Antilles.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NATO Headquarters")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The following NATO headquarters are situated in the Netherlands:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Joint Force Command – Brunssum")])])])]), _c('a', {
    attrs: {
      "id": "title84"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title84"
    }
  }), _c('a', {
    attrs: {
      "id": "title85"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("POLAND")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("POLAND – BASIC FACTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "33.14%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "66.86%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("38 million")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence budget 2010:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 6.2 billion (US$7.5 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GDP 2009:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 331 billion (US$404 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land area:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("312,685 sq kms (120,696 sq miles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Capital:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Warsaw (Population 2.7 million – including Metro area)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Life expectancy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("76.2 years")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population growth rate:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 0.15 per cent")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Total Armed Forces")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "60.00%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "40.00%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army (Land Forces):")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("45,000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Navy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8,000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Force:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("17,000")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Reserves: Under the terms of the latest reorganisation approximately 20,000 ready reserves are available – the majority of which are assigned to the Land Forces.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MINISTRY OF DEFENCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contact Details")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Ministry of Defence")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ul. Klonowa 1")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("PL-009-09 Warsaw")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Poland")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("POLISH LAND FORCES")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Strength:")]), _vm._v(" Approximately 45,000\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Corps Headquarters")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Armoured Division")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("3 x Mechanised Divisions")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Air Assault Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Air Cavalry Brigade")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Land Forces Outline Structure")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "70%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0213.jpg",
      "src": "images/e9781783032051_i0213.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Polish Air Assault Brigade Outline Structure")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "67%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0214.jpg",
      "src": "images/e9781783032051_i0214.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note: Other units such as engineers and fire support elements can be attached where necessary.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Polish Special Forces")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Consists of the following under joint command:\n")])]), _vm._v(" "), _c('ol', {
    staticClass: "al"
  }, [_c('li', {
    staticClass: "asl"
  }, [_vm._v("Special Forces Command Headquarters – Krakow")]), _vm._v(" "), _c('li', {
    staticClass: "asl"
  }, [_vm._v("Operational Mobile Reaction Group (GROM) – Gdansk")]), _vm._v(" "), _c('li', {
    staticClass: "asl"
  }, [_vm._v("Operational Mobile Reaction Group (GROM) – Warsaw")]), _vm._v(" "), _c('li', {
    staticClass: "asl"
  }, [_vm._v("1st Special Commando Regiment – Lubiniec")]), _vm._v(" "), _c('li', {
    staticClass: "asl"
  }, [_vm._v("Naval Special Operations Regiment – Gdynia")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Polish Land Forces – Formation Listing")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "36.09%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "44.67%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "19.23%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1st Mechanized Division")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Legionowo")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1st Mechanized Brigade")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Wesola")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3rd Mechanized Brigade")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Lubin")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("21st Podhale Rifles Brigade")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Rzesz")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("11th Armoured Division")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Zagan")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10th Armoured Cavalry Brigade")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Świętoszow")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("17th Mechanised Brigade")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mieędzyrzecz")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("34th Armoured Cavalry Brigade")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Zagan")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12th Mechanised Division")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Szczecin")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2nd Mechanised Brigade")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Zlocieniec")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("7th Coastal Defence Brigade")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Slupsk")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12th Mechanised Brigade")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Szczecin")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("16th Mechanised Division")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Elblag")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9th Armoured Cavalry Brigade")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Braniewo")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("15th Mechanised Brigade")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Gizycko")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("20th Mechanised Brigade")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Bartoszyce")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Independent Brigades")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("25th Air Cavalry Brigade")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Tomaszow")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6th Air Assault Brigade")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Krakow")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1st Artillery Brigade")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Wegorzewo")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("23rd Artillery Brigade")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Boleslawiec")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1st Engineer Brigade")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Brzeg")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2nd Engineer Brigade")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Kazun Nowy")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Polish Land Forces – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "44.98%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "55.02%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Main Battle Tanks (MBT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("128 x Leopard 2A4")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("About 500 T-72/A/M1/M1D")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("About 220 PT-91/M/MA1")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Reconnaissance (Recce)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("About 300 x BRDM-2 (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Armoured Infantry Fighting Vehicles")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("(AIFV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("About 1,200 x BWP-1 (tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Armoured Personnel Carrier (APC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("300 x KTO Rosomak (Patria) (wheeled – another 390 on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("100 x SKOT (remaining in service)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("40 x Cougar MRAP (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("200 x HMMWV (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Self Propelled Artillery (SP Arty)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("90 x 152 mm Dana")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("500 x 122 mm 2S1 Carnation (majority in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Towed Artillery")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("50 x 122 mm M-30")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Multiple Rocket Launchers (MRL)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("200 x 122 mm BM-21 (majority in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("36 x 122 mm WR-40 Langusta")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("30 x 122 mm RM-70")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Mortars (Mor)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("130 x 120 mm")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("100 x 98 mm")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("150 x 60 mm")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Anti-Tank (Atk)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("110 x AT-3 (MANPAD)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("75 x AT-4 (MANPAD)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("15 x AT-5")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("110 x Spike (154 more on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Low Level Air Defence (LLAD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("245 x GROM SAM (about 75 SP with many in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("60 x SA-8 SP")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("100 x ZSU-23-4 (various types)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("30 x M-24 Hind D (attack)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("30 x PZL W-3 (armed)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("25 x Mi-8 (transport)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("11 x Mi-17 (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("26 x PZL W-4 (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("30 x PZL W-3 (utility – various types)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("POLISH NAVY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Navy Strength:")]), _vm._v(" 8,000")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Principal units:")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("5 x Submarines")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("8 x Frigates and Corvettes")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("19 x Mine Countermeasures Vessels")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Polish Navy Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "59%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0218.jpg",
      "src": "images/e9781783032051_i0218.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Polish Navy – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "42.73%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "57.27%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Submarines Tactical (SSK)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Kobben Class (Type 207)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Kilo Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Frigates (FF)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Pulaski (US Oliver Hazard Perry) Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Corvettes (FS)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Kaszub Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Tarantula Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("3 x Orkan Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Mine Countermeasures (MCM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("12 x Goplo (minesweeper)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("4 x Mamry (minehuner)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("3 x 206 FM (minehunter)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Amphibious Vessels (LS)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("5 x Lubin (landing ships)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("3 x Deba (landing craft)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("15 x assorted landing craft")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Miscellaneous (Misc)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("2 x Tankers")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("3 x Salvage Vessels")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("2 x Intelligence Vessels")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("6 x Survey Vessels")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("3 x Tugs (ocean capability)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("8 x Training Vessels")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Naval Aviation")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("12 x An-28 (transport – fixed wing)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("4 x Kaman SH-2 (ASW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("14 x PZL W-3 (SAR and utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("10 x Mi-14 (SAR and ASW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("5 x PZL W-2 (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("4 x M-17 (transport)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("POLISH AIR FORCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Air Force Strength:")]), _vm._v(" 17,000")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Polish Air Force Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "68%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0221.jpg",
      "src": "images/e9781783032051_i0221.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note: Combat aircraft squadrons are under the command of both 1 Tactical Air Wing ( 5 x squadrons) and 2 Tacticai Air Wing (3 x squadrons). There are 4 x Controi and Reporting Centres (CRC).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Polish Air Force – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "50.50%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "49.50%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighters (Ftr)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("28 x Mig-29A")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighter Ground Attack (FGA)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("45 x Su-22M-4")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Multi Role")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("36 x F-16C")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x F-16D")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport (Tpt)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x C-130E Hercules")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x An-28")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("11 x CASA-295M")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("15 x M-28 (12 more on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Tu-154")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Training (Trg)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x Mig-29UB")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("30 x PZL-130")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("52 x PZL TS-11 (being retired)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Mi-8S (VIP transport)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("11 x Mi-8 (transport)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("50 x Mi-2 (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("7 x Mi-17 (transport)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("24 x PZ W-3 (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("24 x PZL W-4 (utility and training)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Bell 412 (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air launched missiles (ALM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AA-8 (AAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AIM-9 Sidewinder (AAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AA-11 (AAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AMRAAM (AAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("ASM-7 (SM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Maverick (ASM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Surface to Air Missiles (SAM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("75 x SA-3 (many in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("60 x SA-3 SP (many in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("14 x SA-4 SP")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x SA-5 (static)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CURRENT UNIT DEPLOYMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("(over platoon strength – 30 personnel. These are approximate figures)")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "65.33%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "34.67%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (ISAF) Afghanistan")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 2,500")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EUFOR Bosnia")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 160")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("KFOR Kosovo")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 227")])])])])])])]), _c('a', {
    attrs: {
      "id": "title85"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title85"
    }
  }), _c('a', {
    attrs: {
      "id": "title86"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PORTUGAL")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PORTUGAL – BASIC FACTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "41.73%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "58.27%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10.6 million")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence budget 2010:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 1.9 billion (US$2.3 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GDP 2009:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 162 billion (US$198 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land area:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("91,500 sq kms (35,192 sq miles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Capital:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Lisbon (Population 1.9 million)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Life expectancy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("76 years")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population growth rate:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("0.1 per cent")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Total Armed Forces")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "26.87%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "73.13%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("24,500 (with about 20,000 ready reserves and another 150,000 said to be available)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Navy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10,000 (including about 1,400 marines)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Force:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("7,000")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(Conscription has recently ended)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MINISTRY OF DEFENCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contact Details")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Ministry of Defence")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Avenida Ilha da Madeira 14")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("P-1400 Lisbon")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Portugal")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Tel: +351 21301 0001")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Fax: +351 21302 0284")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PORTUGUESE ARMY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army Strength")]), _vm._v(": approximately 24,500 (with about 20,000 ready reserves and another 150,000 said to be available).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In general terms and available for immediate operations are:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Light infantry brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Mechanised infantry brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Rapid Reaction/Airborne brigade")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The following diagram shows the outline structure of the Portuguese Army:")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "69%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0226.jpg",
      "src": "images/e9781783032051_i0226.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) The Mechanised Infantry Brigade (1st Independent Mixed Brigade) is earmarked for operations in support of the NATO Allied Rapid Reaction Corps (ARRC). This Iorigade has 2 x mechanised infantry battalions. 1 x armoured reconnaissance squadron, 1 x artillery battery, 1 x tank squadron+, 1 x air defence battery, 1 .x engineer company and 1 x command and service support battalion. The Light Infantry Brigade has a similar structure but without armoured units.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) The Rapid Reaction/Airborne Brigade also has a NATO role. Based around 2 x parachute battalions it has air defence, anti-tank, artillery, engineer, reconnaissance and support elements.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(3) There are three Territorial Defence (Reserve) Brigades availalole on mobilisation.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("EU Arrangements")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Portugal is committed to taking part in the EU Multinational Battlegroup being formed with Greece, Italy and Spain. This Battlegroup should be operational by the end of 2007 and will be at between five and seven days notice to move.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Portugal is also part of EUROFOR (European Rapid Operational Force), an Italian led formation with its headquarters in Florence. Other nations contributing forces are France and Spain.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Portuguese Army – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "42.90%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "57.10%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Main Battle Tanks (MBT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("90 x M-60A3/A4 (possible 40 active)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("37 x Leopard 2A6 (from the Netherlands)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("86 x M-48 (majority in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Reconnaissance (Recce)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("15 x V-150 Chaimite (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("20 x ULTRAV M-11 (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("25 x VBL (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Personnel Carrier(APC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("200 ( – ) x M-113 (tracked – estimate available)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("40 x M-557 (tracked – M-113 variant)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("240 x Pandur II (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("70 x V-200 Chaimite (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Self Propelled Artillery (SP Arty)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("20 x 155 mm M-109A2/A5")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Towed Artillery (Towed)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("21 x 105 mm L-119")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("50 x 105 mm M-101")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("24 x 105 mm M-56 (possibly in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("24 x 155 mm M-114")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mortars (Mor)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("150 x 81 mm (estimate in service)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("80 x 120 mm (estimate in service)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Anti-Tank (Atk)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("75 x Milan ATGW (possibly 6 x SP)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("60 x TOW ATGW (possibly 20 SP)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("150 x 84 mm Carl Gustav RL")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Low Level Air Defence (LLAD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x Stinger SAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("35 x Chaparral SAM (possibly 12 in service)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("25 x 20 mm Guns")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("50 x 40 mm L/60 Guns (possibly in store)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PORTUGUESE NAVY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Navy Strength")]), _vm._v(": approximately 10,000 including about 1,400 marines.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Principal units:")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Submarine")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("6 x Frigates")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("8 x Offshore patrol craft")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Portuguese Navy Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0228.jpg",
      "src": "images/e9781783032051_i0228.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1)The Territorial Command has the responsibility for the Azores. Madeira. South Continental and North Continental.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) There are naval hases at Funchal, Lisbon, Porto, Portimao and Ponta Delgada.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Marines")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Portuguese Marine Corps (Fuzileiros Navais – FN) has the following outline structure:")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "62%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0229.jpg",
      "src": "images/e9781783032051_i0229.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The total strength of the FN is in the region of 1,400 personnel. Equipment includes 20 x Pandur APC and 120 mm Mortars.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("European Union Arrangements")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Portugal is a contributor to the European Maritime Force (EUROMARFOR) together with France, Italy and Spain.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Portuguese Navy – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "37.05%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "62.95%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Tactical Submarines (SSK)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Albacora (Daphne Class)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Type 209 (on order from Germany)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Frigates (FF)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Vasco Da Gama (Meko 200)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Commandante Joao Belo")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Karel Doorman (from Netherlands)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Patrol Vessels (PV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Baptista de Andrade (offshore)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Jao Coutinho (offshore)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Viana de Andrade (offshore with helicopter)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Cacine (coastal)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x Argus (inshore)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Centauro (inshore)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Albatros (inshore)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Miscellaneous")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x Survey Vessels")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Small Tanker")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Landing Ship")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Naval Aviation")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x Super Lynx (utility & ASW)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PORTUGUESE AIR FORCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Air Force Strength")]), _vm._v(": approximately 7,000 (plus about 2,000 reserves).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Outline structure")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "71%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0231.jpg",
      "src": "images/e9781783032051_i0231.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) Sintra Air Base provides survey, mapping, EEZ patrol and general support using mainly C-212 types.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) Lajes Air Base uses 0-212-100 aircraft and SA-330 to provide transport and SAR.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(3) Monte Real Air Base employs F-16 aircraft in the attack and air defence roles.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(4) Montijo Air Base used Orion aircraft for maritime patrol, C-130 Hercules and Falcon aircraft for transport and SA 330 and EH 101 helicopters for both transport and S&R")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(5) Training is conducted at Bela Air Base using Alpha Jets, Epsilon and Allouette III helicopters.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Portuguese Air Force – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "39.30%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "60.70%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighters (FTR)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("21 x F-16A/B (19 more in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Reconnaissance (Recce)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x CASA 212-300")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport (TPT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("24 x CASA 212A/B (being replaced by 12 x C-295M)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x C-130H Hercules")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Falcon 50")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Maritime Reconnaissance (MR)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x P-3P Orion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Training (Trg)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("30 x Alpha Jet (many in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("15 x TB-30 Epsilon")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x EH 101 (support & SAR)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("16 x SA-316 Alouette III (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x SA-330 (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air launched missiles (ALM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AGM-65 Maverick (ARM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AGM-88 Harpoon (ASM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AIM-120 AMRAAM (AAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AIM-9 Sidewinder (AAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AIM-7 Sparrow (AAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Defence")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x I Hawk (SAM – probably in store)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CURRENT UNIT DEPLOYMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("(over platoon strength – 30 personnel. These are approximate figures)")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "62.69%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "37.31%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (ISAF) Afghanistan")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 150")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (KFOR) Kosovo")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 275")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("EUFOR Bosnia")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("- 50")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("UNIFIL Lebanon")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("- 150")])])])])])])]), _c('a', {
    attrs: {
      "id": "title86"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title86"
    }
  }), _c('a', {
    attrs: {
      "id": "title87"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ROMANIA")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ROMANIA – BASIC FACTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "42.54%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "57.46%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("22 million")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence budget 2010:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 1.90 billion (US$2.3 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GDP 2009:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 122 billion (US$148 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land area:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("238,391 sq kms (91,688 sq miles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Capital:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Bucharest (Population 1.9 million)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Life expectancy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("72.5 years")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population growth rate:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("0.13 per cent")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Total Armed Forces")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "25.06%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "74.94%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Approximately 41,000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Navy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Approximately 6,900")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Force:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Approximately 10,000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Reserves:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mainly army and reports vary – possibly 20,000 effective (within 5 years of demobilisation)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Romania joined the European Union in January 2007 following its accession to NATO in April 2004. The Ministry of Defence continues restructuring to conform to NATO standards.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MINISTRY OF DEFENCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contact Details")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Ministry of National Defence")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("3-5 Strada Izyor")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Bucharest 050561")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Tel: +4021 319 5698")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Fax: +4021 319 5698")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ROMANIAN ARMY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army (Land Forces) Strength")]), _vm._v(": Approximately 41,000 (Possibly 20,000 effective reserves).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army Outline Structure")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "70%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0237.jpg",
      "src": "images/e9781783032051_i0237.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "61%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0238.jpg",
      "src": "images/e9781783032051_i0238.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note: Divisional Troops include: 1 x Recce Bn; 1 x Military Police Bn; NBC Defence Bn; 2 x Air Defence Bns; 1 x Signal Bn; 1 x Engineer Bn; 1 x HQ and Command Bn.")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "66%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0239.jpg",
      "src": "images/e9781783032051_i0239.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note: Divisional Troops include: 1 x Recce Bn; 1 x Military Police Coy; NBC Defence Coy; 1 x Signal Coy; 1 x HQ and Command Bn.")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "70%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0240.jpg",
      "src": "images/e9781783032051_i0240.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note: Divisional Troops include: 1 x Recce Bn; 1 x NBC Defence Bn; 1 x Amphihious Engineer Bn; 1 x Signal Coy; 1 x HQ and Command Bn.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("EU Battlegroup: From June to December 2010 Romania joined with Italy to provide the standby EU Battlegroup.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Romania – Army (Land Forces) – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "49.19%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "50.81%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Main Battle Tanks (MBT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("150 x T-55")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("40 x TR-77-580 (T-55 type)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("105 x TR-85 (T-55 type)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Infantry Fighting Vehicles (AIFV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("30 x MLI-84 (BMP-1 type)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Personnel Carrier (APC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("31 x Pirhana IIIC (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("65 x TAB B33 (BTR-80 type wheeled)")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "36.88%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "63.12%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x TAB-77 (BTR-70 type – wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("300 x TABC-79 (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Some TAB-71 remain (wheeled BTR-60 type)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Towed Artillery (Arty)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("200 x 152 mm D-20 Model 1981 (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x 152 mm 2A65 Model 1989 (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("50 x 122 mm M-1938")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Self Propelled Artillery (SP)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x 122 mm 2S1")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("18 x 155 mm ATMOS 2000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Multiple Rocket Launchers (MRL)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x APR-40 (improved BM-21 type – operational estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mortars (Mor)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x 120 mm 120-PM-43 (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("200 x 82 mm 82-PM-41 (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Anti-Tank (Atk)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("73 mm AG9 RL")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x AT-3 Sagger types (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("50 x AT-5 Spandrel")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Low Level Air Defence (LLAD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("18 x 35 mm Gepard SP")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("24 x 35 mm GDF-203 towed")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("MICA on order")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ROMANIAN NAVY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Navy Strength")]), _vm._v(": Approximately 6,900")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Principal units:")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("3 x Frigates")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("4 x Corvettes")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("16 x Patrol Vessels")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("5 x Mine Warfare Vessels")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Romanian Navy Outline Organisation")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Fleet Headquarters is at Constanta and there is a Frigate Flotilla, an Operational Command Group and a River Flotilla (Danube).")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("A Kilo class submarine that is held in reserve could be reactivated if funds become available.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Many vessels are believed to be undermanned.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("307 Marine Infantry Battalion (Badadag) operates as a Special Forces Unit.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Romanian Navy – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "47.45%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "52.55%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Frigates (FF)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Marasesti Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Regele Ferdinand Class (ex UK Type 22)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Corvettes (FS)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Tetal I/II")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Patrol and Coastal Combatants (PCC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Zborul with Styx SSM (offshore)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x Brutar (inshore/river)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Kogalniceanu (inshore/river)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x River patrol craft (ex minesweepers)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mine Countermeasures (MCM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Offshore minesweeps")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Minelayer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x River Minesweepers")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Miscellaneous")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Auxiliary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Research vessel")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Survey Ship")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Ocean going tug")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ROMANIAN AIR FORCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Air Force Strength")]), _vm._v(": Approximately 10,000.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Romanian Air Force Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "68%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0244.jpg",
      "src": "images/e9781783032051_i0244.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Romanian Air Force – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "37.56%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "62.44%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighters (FTR)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("20 x Mig-21 Lancer C")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighter Ground Attack (FGA)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("28 x Mig-21 Lancer A/B")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport (Tpt)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x An-26 Curl")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x C-130 (1 x C-130H & 4 x C-130B)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x C-27J Spartan (2 more on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x An-30 Clank (also used for recce/survey)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Training (Trg)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x An-2 (biplane)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("20 x IAR-99 (light attack and lead in)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x IAK-52")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("60 x IAR-330 Puma SOCAT & SA-330 (support)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x IAR-316b Alouette III")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air launched missiles (ALM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AA-8 Aphid AAM; AA-11 Archer AAM; Python 3 AAM;")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("R-550 Magic AAM;")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Spike-ER ASM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Unmanned Air Vehicles (UAV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10 x Shadow 600")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Surface to Air Missiles (SAM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x Hawk PIP III")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x SA-2 Guideline – possibly withdrawn")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CURRENT UNIT DEPLOYMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("(over platoon strength – 30 personnel. These are approximate figures)")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "74.48%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "25.52%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (ISAF) Afghanistan")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 960")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (KFOR) Kosovo")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 150")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EUFOR Bosnia")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 50")])])])])])])]), _c('a', {
    attrs: {
      "id": "title87"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title87"
    }
  }), _c('a', {
    attrs: {
      "id": "title88"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SLOVAKIA")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SLOVAKIA – BASIC FACTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "39.18%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "60.82%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5.4 million")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence budget 2010:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 900 million (US$ 1,098 million)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GDP 2009:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 90 billion (US$109 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land area:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("49,035 sq kms (18,932 sq miles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Capital:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Bratislava (Population 455,000)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Life expectancy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("75.4 years")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population growth rate:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("0.12 per cent")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Total Armed Forces")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Army (Land Forces):")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("7,000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Air Brigade:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("4,000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Training & Support Command:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("3,500")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Central Staff (including medical):")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("1,500")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Ready Reserves:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("5,000")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note: All figures above are approximate. Conscription was abolished in 2006.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The plan for the Slovakian 2015 Armed Forces structure calls for a fully professional force of around 22,000 personnel. Due to recent financial difficulties this may be difficult to achieve.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Slovakia provides a contingent to the EU’s Czech-Slovak Battle Group.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MINISTRY OF DEFENCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contact Details")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Ministry of Defence")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Kutuzovova 8")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("83247 Bratislava")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Slovakia")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SLOVAKIAN ARMED FORCES")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army Strength:")]), _vm._v(" approximately 7,000")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "64%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0249.jpg",
      "src": "images/e9781783032051_i0249.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) Units under direct command of the Joint Forces Headquarters include 1 x Special Forces Group (5th Battalion), 1 x Communication Battalion, 1 x Military Police Battalion and 1 x Reconnaissance Battalion.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) The operational units of the Aviation and Air Defence Brigade include a Combat Flight Base (Silac), 1 x Transport Squadron (Kuchyna), 1 x Helicopter Battalion (Presov) and 1 x Air Defence Battalion (Nitra).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Slovakian Brigade Outline")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "72%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0250.jpg",
      "src": "images/e9781783032051_i0250.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note: The 2nd Brigade includes 1 x Mixed Mechanised Battalion (with T-72 MBT), 1 x Artillery Battalion and 1 x Engineer Battalion. Company sized elements are attached to the Brigade depending upon the operational requirement.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Slovak Land Forces – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "42.22%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "57.78%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Main Battle Tanks (MBT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("200 x T-72M – some M1A (many T-72M in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Infantry Fighting Vehicles the (AIFV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("250 x BVP-1 (tracked – many probably in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("90 x BVP-2 (tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Personnel Carrier(APC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x OT-90 (tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Self Propelled Artillery (SP Arty)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("119 x 152 mm Dana SP")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("16 x 155 mm M-2000 Zuzana")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Towed Artillery (Towed)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("50 x 122 mm D-30")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Multiple Rocket Launchers (MRL)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("50 x 122 mm RM-70")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("26 x 227 mm RM-70 MODULAR")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mortars (Mor)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("30 x 120 mm (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Anti-Tank (Atk)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Possibly 200 x AT-5 SP on BMP")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Some AT-3 probably remain in service")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Possibly 100 x AT-4")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Low Level Air Defence (LLAD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("SA-16 & SA-7 (MANPADS)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aviation & Air Defence Brigade Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "35.75%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "64.25%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighters (FTR)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("21 x Mig-29 UB (12 modernised to NATO standard)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Training (Trg)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("13 x L-39 Albatross")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport (Tpt)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x An-26")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("7 x L-410")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x Mi-24D (attack)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x Mi-17 Hip H (support)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x Mi-2 Hopolite (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Defence (AD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("14 x SA-6 Gainful (launchers)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x SA-10 Grumble (launchers)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("48 x SA-13 Gopher SP on MTLB")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CURRENT UNIT DEPLOYMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("(over platoon strength – 30 personnel. These are approximate figures)")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "64.18%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "35.82%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (ISAF) Afghanistan")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 230")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (KFOR) Kosovo")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 146")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EUFOR Bosnia")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 30")])])])])])])]), _c('a', {
    attrs: {
      "id": "title88"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title88"
    }
  }), _c('a', {
    attrs: {
      "id": "title89"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SLOVENIA")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SLOVENIA – BASIC FACTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "39.38%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "60.62%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2.025 million")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence budget 2010:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 514 million (US$627 million)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GDP 2009:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 35 billion (US$43 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land area:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("20,100 sq kms (7,731 sq miles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Capital:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Ljubljana (Population 258,000)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Life expectancy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("76 years")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population growth rate:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("0.3 per cent")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Total Armed Forces")])]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land Element (Army):")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("7,000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Maritime Service:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("60")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Element:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("550")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MINISTRY OF DEFENCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contact Details")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Ministry of Defence")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Vojkova Cesta 55")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1000 Ljubljana")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("SLOVENIA")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Tel: +386 1 133 11 11")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Fax: +386 1 131 81 64")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SLOVENIAN ARMY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army Strength:")]), _vm._v(" 7,000 (with approximately 3,000 ready reserves).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In the main Slovenian reserves consist of 6 x infantry battalions, 2 x artillery battalions, possibly 1 x tank battalion, 1 x air defence battalion and 1 x reconnaissance battalion.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Slovenia provides a contingent to the EU Balkan Battlegroup with other contingents from Greece, Bulgaria, Cyprus, and Romania.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Outline Army Structure")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0255.jpg",
      "src": "images/e9781783032051_i0255.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) The Force Command directly commands 1 x Special Forces Group, 1 x Mditary Police Bn, 1 x Recce Bn, 1 x Communications Bn and the Naval Detachment.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) The 20th Mechanised Infantry Battalion from the 1st Brigade is the Slovenian contribution to the NATO Multinational Land Force (MLF). With contributions from Italy, Slovenia and Hungary the MLF consists of a light infantry brigade at high readiness. MLF HQ is at Udine in Italy.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Military Districts (MD) are as follows:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("MD 1: Domzale, Grosuplje, Logatec")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("MD 2: Cerknica, Ilirka Bitsrica, Izola, Sezana")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("MD 3: Tolmin")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("MD 4: Loka, Radovljica, Skofja")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("MD 5: Brezice, Cromelj, Ribnica")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("MD 6: Sloven Konjice, Slovenj Gradec, Trbovlje, Valenje, Zalec")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("MD 7: Bistrica, Ljutomer, Murska; Ptuj, Sobota, Slovenska")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Slovenia – Army – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "68.57%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "31.43%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Main Battle Tanks (MBT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("40 x M-84A")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("25 x T-55")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Armoured Infantry Fighting Vehicles")])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "55.00%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "45.00%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("(AIFV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("50 x M-80")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Armoured Personnel Carrier (APC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("30 x BOV (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("75 x Pandur (Valuk) (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("135 x Patria on order")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Towed Artillery (Towed)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("12 x 105 mm M2-A1 (probably in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("18 x 155 mm TN-90")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Mortars (Mor)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("50 x 82 mm (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("50 x 120 mm (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Anti-Tank (ATK)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("50 x AT3/AT4 (estimate) some on BOV-3 (ATGW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("500 x RPG-7, M80 and RPG-22 (RL)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NAVY (SLOVENIAN MARITIME SERVICE)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Maritime Service Strength")]), _vm._v(": approximately 60")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Principal units:")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Super Dvora MkII Coastal Patrol Vessel")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This extremely small navy concentrates on search and rescue plus patrol duties in the Slovenian EEZ. There are a small number of rubber boats for inshore patrol duties.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("AIR ELEMENT")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Air Element Strength: approximately 550")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The majority of the Slovenian Air Element is located at the Cerklje ob Krki Airbase.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Slovenian Air Force – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "38.66%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "61.34%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport (Tpt)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x L410 Lear Jet")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x PC-6")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Training (Trg)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("11 x PC-9/M (some armed)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Zlin L-143")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x Zlin L-242")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Bell 206B (training)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x Bell 412 EP (some armed)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x AS 532 Cougar (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Defence (AD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x Roland 2 SAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("30 x SA-16 (Gimlet) SAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x SA-18 (Grouse) SAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x 20 mm guns on BOV-3 SP AAG")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CURRENT UNIT DEPLOYMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("(over platoon strength – 30 personnel. These are approximate figures)")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "75.13%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "24.87%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (ISAF) Afghanistan")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 150")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (KFOR) Kosovo")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 365")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EUFOR Bosnia")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 30")])])])])])])]), _c('a', {
    attrs: {
      "id": "title89"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title89"
    }
  }), _c('a', {
    attrs: {
      "id": "title90"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SPAIN")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SPAIN – BASIC FACTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "44.49%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "55.51%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("40 million")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence budget 2010:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 11.9 billion (US$14.5 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GDP 2009:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 1,033 billion (US$1,256 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land area:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("499,400 sq kms (192,078 sq miles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Capital:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Madrid (Population 5 million)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Life expectancy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("79 years")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population growth rate:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("0.1 per cent")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Total Armed Forces")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "27.43%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "72.57%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("80,000 (plus about 200,000 reserves – possibly 20,000 ready reserves)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Navy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("17,500 (plus about 5,000 reserves)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Force:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("21,000 plus about 5,000 reserves)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Joint (MoD):")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("About 9,000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Guardia Civil")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("About 70,000")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MINISTRY OF DEFENCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contact Details")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Ministry of Defence")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Paseo de la Castellana 109")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("28071 Madrid")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Spain")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Tel: +34 1 555 26 00")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Fax: +34 1 556 55 72")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ARMY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army Strength")]), _vm._v(": 80,000 (plus about 200,000 reserves – possibly 20,000 ready reserves)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Spanish Army Outline Organisation")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Land Forces HQ")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Logistic Support Command\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("4 x Territorial Commands")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Divisional Type Formations with 8 x deployable brigades")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Special Forces Command")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Field Artillery Command")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Air defence Artillery Command")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Coastal Artillery Command")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Engineer Command")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Army Aviation Command")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Signals Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("NATO Rapid Deployment Corps HQ (NATO RDC)")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "59%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0263.jpg",
      "src": "images/e9781783032051_i0263.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note: NATO RDC (Rapid Deployment Corps HQ).")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "72%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0264.jpg",
      "src": "images/e9781783032051_i0264.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Heavy Forces")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "62%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0265.jpg",
      "src": "images/e9781783032051_i0265.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note: 1 Land Forces Command is otherwise knoxvn as 1 Mechanised Division.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Light Forces")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "69%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0266.jpg",
      "src": "images/e9781783032051_i0266.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note: This formation is otherwise knovm as the FAR (Rapid Reaction Force).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("EU Battlegroups:")]), _vm._v(" Spain provides 1 x complete Battlegroup from its own resources, takes part in the French-German Battlegroup and provides is a major contributor to the Spanish-Italian Amphibious Battlegroup.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Spain – Army – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "38.25%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "61.75%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Main Battle Tanks (MBT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("239 x Leopard 2E (possibly operational)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("50 x M-60A3 (in reserve)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Reconnaissance (Recce)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("80 x B-1 Centauro (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("90 x Pegaso VEC-M1 (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("185 x IVECO LAV – Panther (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Infantry Fighting Vehicles ( AIFV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("212 x Pizarro (tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Personnel Carrier (APC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("400 M-113 (tracked) Estimate in service - being replaced by Pizarro")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("500 x BMR-600/600M1 possibly (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x RG-31 Nyala (wheeled – mine resistant)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Towed Artillery (Arty)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("58 x 105 mm L-118 Light Gun")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("150 x 105 mm Model 56 Pack How (many in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("18 x 155 mm SBT-1")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("70 x 155 mm SBT-1 (on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Self Propelled Artillery (SP Arty)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("96 x 155 mm M-109A5")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Coastal Artillery")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x 155 mm; 3 x Vickers 305 mm; 3 x 381 mm; 30 x Vickers")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("152 mm (some inactive)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mortars (Mor)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1000 x 81 mm ECIA L65/81 (possibly 500 SP)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("400 x 120 mm ECIA L65/120 (possibly 100 SP)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Multiple Rocket Launcers (MRL)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("14 x 140 mm Teruel")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Anti-Tank (Atk)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100 x Milan ATGW SP")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("60 x TOW ATGW SP")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("260 x SPIKE ATGW")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("275 x Milan ATGW")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("130 x TOW ATGW")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Low Level Air Defence (LLAD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("18 x Roland SAM SP")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("36 x I Hawk SAM (towed)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x Skyguard/Aspide SAM (towed)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x MIM-104 Patriot 2 (towed)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("160 x Mistral SAM (MANPAD)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x NASAMS")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("150 x 20 mm GAI-BO1 AAA")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("90 x 35 mm GDF-005")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army Aviation")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AAS-665 Tiger Attack (24 on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9 x OH-58 Kiowa Liaison")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("17 x CH-47 Chinook (Transport)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("16 x AS-332 Super Puma (Transport)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("27 x Bo-105 (Utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x Bell 212 (Utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x AS532UC Cougar (Utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("20 x UH-1H (Utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("45 x NH90 planned (for all three services)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SPANISH NAVY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Navy Strength")]), _vm._v(": 17,500 (plus about 5,000 reserves).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Principal units:")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("4 x Submarines")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Aircraft Carrier")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("11 x Frigates")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("7 x Mine Warfare Vessels")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Spanish Navy Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "71%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0268.jpg",
      "src": "images/e9781783032051_i0268.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note: Special Operations Command includes the Special Operations Group and the Combat Diver Group. The Special Operations Group is trained in maritime counter-terrorism, combat diving and swimming, coastal infiltration, ship boarding, direct action, and special reconnaissance. The Combat Diver Group is trained in underwater demolitions and hydrographic reconnaissance.")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "72%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0269.jpg",
      "src": "images/e9781783032051_i0269.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Spanish Navy – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "40.58%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "59.42%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Submarines Tactical (SSK)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x S-70 Galerna Class (4 x S-80 Class on order – first delivery probably early 2014)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Aircraft Carrier")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x R- 11 Príncipe de Asturias")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Frigates")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x F-100 Álvaro de Bazán class 2 more on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x F-80 Santa María class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mine Countermeasures (MCM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x M-30 Segura class Minehunters")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Modified Descubierta Class MCM support ship")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Patrol and Coastal Combatants (PCC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Serviola (PCO)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Alboran (PCO)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Descubierta (PCO)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9 x Anaga (PCO)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x BAM (PCO)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x Coastal Patrol Craft")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x River Patrol Craft")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Amphibious (Amphib)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("2 x L-50 Galicia class LPD (450 troops)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("1 x L-40 Newport class LST")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("1 x Juan Carlos Class LHD (700 troops)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Miscellaneous (Misc)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("1 x Replenishment Ship")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("1 x Fleet Oiler")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("1 x Logistic Ship")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("2 x Cargo Ships")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("1 x EW Support Ship")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("1 x Submarine Rescue Vessel")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("1 x Salvage Tug")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("1 x Polar Research Vessels")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("7 x Hydrographic Vessels")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Naval Aviation")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("16 x AV-8B Harrier 2/Harrier 2 Plus (Attack)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("7 x P-3 Orion (Maritime Patrol)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("3 x Citation 2 (Transport)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("12 x SH-60B Seahawk ASW")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("3 x SH-3D AEW")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("9 x SH-3 AEW")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("6 x Bell 212 (Utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("9 x Hughes 500MD")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Air Launched Missiles (ALM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Maverick (ASM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Penguin (ASM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("AMRAAM (AAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Sidewinder (AAM)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SPANISH AIR FORCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Air Force Strength")]), _vm._v(": 21,000 plus about 5,000 reserves.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Spanish Air Force Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "68%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0272.jpg",
      "src": "images/e9781783032051_i0272.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Spanish Air Bases")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "43.55%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "56.45%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Madrid-Torrejón Air Base")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("McDonnel Douglas F/A-18 Hornet")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Canadair CL-215")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Airbus A310")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Dassault Falcon 900")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Dassault Falcon 20")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Boeing 707 Transport/Tanker")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("CASA C.212 Aviocar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Madrid – Getafe Air Base")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("CASA CN-235")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("CASA C-295")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Beechcraft Bonanza")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Madrid – Cuatro Vientoos Air Base")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Puma (Hel)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Cougar (Hel)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("CASA C.212 Aviocar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Cessna Citation V")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Salamanca – Matacan Air Base")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("CASA C-101")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("CASA C.212 Aviocar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Valladolid – Villanubla Air Base")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("CASA C.212 Aviocar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Albacete – Los Llanos Air Base")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Dassault Mirage F1")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Seville – Moron Air Base")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Eurofighter Typhoon")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Badajoz – Talavera Air Base")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("20 x F-5B Freedom Fighter (Trainer)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Murcia – Alcantarilla Air Base")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("CASA C.212 Aviocar (Parachute School)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Granada – Armilla Air Base")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("S-76 (Hel)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("EC 120 Colibri (Hel)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Murcia – San Javier Air Base")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("T-35C")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("D0 27")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("CASA C-101")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("CASA C.212 Aviocar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Zaragoza Air Base")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("McDonnel Douglas F/A-18 Hornet")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Lockheed C-130 Hercules")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Mallorca – San Juan Air Base")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("CASA C.212 Aviocar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Puma (Hel)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Las Palmas – Gando Air Base")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("McDonnel Douglas F/A-18 Hornet")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Fokker F27 Maritime")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Cougar (Hel)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "colspan": "2"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Note:")]), _vm._v(" MACEN – Central Air Command")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Spanish Air Force – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "35.56%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "64.44%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighters (FTR)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("30 x Typhoon (87 on order – 71 single seat and 16 dual seat)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("36 x Mirage F1M")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Mirage F1BM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighter Ground Attack (FGA)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("88 x FA-18A/FA-18B")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("(67 x FA-18s being upgraded (MLU)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Maritime Patrol (MP)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("7 x P-3 (2 x A, 2 x B and 3 x M)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x CN 235")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport (Tpt)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x C-130H Hercules")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x A-310-314")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Boeing 707")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("35 x CASA 212 Avoicar (estimate in service)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x Falcon 900")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x CN 235")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x CN 295")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("27 x Airbus A-400M (on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Reconnaissance (Recce)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Cessna Citation V (Cartography)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x IAI Boeing 707")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Tanker (Tkr)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x KC-130H Hercules")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Boeing 707")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Training (Trg)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("20 x F-5B Freedom Fighter (Lead in trainer)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("25 x F33 Bonanza")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("35 x T-35")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("45 x CASA C-101 (Estimate in service)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("14 x CL-215 (Fire fighting)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("3 x CL-415 (Fire fighting)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("4 x SA-330 Puma (support)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("11 x AS-332 Super Puma (support)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("8 x S76-C Spirit (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("2 x AS-532 (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("15 x EC-120 Colibri (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Air Defence")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Mistral SAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Skyguard/Aspide")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Air launched missiles (ALM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("AGM-84C/D Harpoon ASM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("AGM-65A/G Maverick ASM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("AGM-88A HARM ARM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("AIM-7F Sparrow AAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("AIM-120B/C AMRAAM ASM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("AIM-9L/M/N/P Sidewinder AAM")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CURRENT UNIT DEPLOYMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("(over platoon strength – 30 personnel. These are approximate figures)")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "67.50%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "32.50%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (ISAF) Afghanistan")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 1050")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EUFOR Bosnia")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 300")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("UNIFIL – Lebanon")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 1,000")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NATO Headquarters")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The following major NATO headquarters are situated in Spain:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Joint Force Component Command Land – Madrid")])])])]), _c('a', {
    attrs: {
      "id": "title90"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title90"
    }
  }), _c('a', {
    attrs: {
      "id": "title91"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SWEDEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SWEDEN – BASIC FACTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "43.87%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "56.13%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9.2 million")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence budget 2010:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 4.1 billion (US$5 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GDP 2009:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 314 billion (US$383 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land area:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("449,964 sq kms (173,063 miles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Capital:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Stockholm (Population 1.9 million)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Life expectancy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("80 years")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population growth rate:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("0.3 per cent")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Total Armed Forces")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "24.68%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "75.32%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Approximately 6,000 available")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Navy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Approximately 2,500 available including about 500 coastal defence personnel")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Force:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Approximately 2,750 available")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Home Guard:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Reducing to 22,000")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In July 2010 the Swedish Armed Forces finally abolished the system of conscription that had been in place for many years. Units of all three armed services are reinforced by Home Guard volunteers should the requirement arise.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MINISTRY OF DEFENCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contact Details")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Ministry of Defence")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Regeringsgatan 1-3")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("S-01333 Stockholm")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("SWEDEN")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Tel: +46 8 763 10 00")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ARMY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army Strength")]), _vm._v(": Approximately 6,000 available.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Following the abolition of conscription, the current aim is to have an army that can provide 8 x mechanised battalions with support from another 19 x battalions composed of engineers, artillery, communications, logistics, maintenance and so on.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Swedish Army currently operates with the following formations/units:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Divisional Headquarters (activated only on mobilisation)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Brigade Headquarters")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Units Available:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Infantry Battalion (Life Guards – Ceremonial & training – Stockholm)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Cavalry Battalion (Ceremonial & training – Stockholm)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("6 x Armoured/Mechanised Battalions (Boden/Revingehed/Skovde)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Air Assault Battalion (Karlsborg)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x ISTAR Battalion (Karlsborg)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Communications Battalion (Enkoping)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Artillery Regiment (Boden)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Air Defence Regiment (Halmstad)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Engineer Battalions (Eksjo)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Arctic Engineer Company (Boden)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x CBRN Defence Company (Umea)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("4 x Logistic Battalions (Skovde)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Nordic Battlegroup")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Sweden is the host country for the Nordic Battlegroup which consists of around 2,800 soldiers and officers, with manpower/unit contributions from the following five countries:")])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "42.16%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "57.84%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Sweden")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2,300")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Finland")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Norway")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("150")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Ireland")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Estonia")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("50 (approx)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Nordic Battlegroup was designated as on operational standby between January 2008 and June 2008.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Home Guard")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Home Guard ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Hemvarnet")]), _vm._v(") currently consists of 60 battalions with a total of about 42,000 personnel. By 2014 the Home Guard will be better organised and better trained and consist of approximately 22,000 personnel.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("All Home Guards are former active soldiers who volunteered for Home Guard service and many have served abroad in the various missions of the regular armed forces.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("About 22 Training Detachments support both the Regular Army and the Home Guard.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Sweden – Army – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "45.40%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "54.60%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Main Battle Tanks (MBT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("160 x Leopard 2A4 (Striv-121)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("120 x Leopard 2 (Striv-122)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Infantry Fighting Vehicles (AIFV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("360 x CV 9040 (Tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Armoured Personnel Carrier (APC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("200 x Pbv-401 (Tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("300 x Pbv-302 (Tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("50 x Viking (Tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("160 x Sisu (Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("60 x RG32M (wheeled – mine resistant)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Towed Artillery (Arty)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("50 x 155 mm FH-70 (Towed)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Self Propelled Artillery (SP)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("24 x 155 mm Archer (SP-Wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Mortars (Mor)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("180 x 120 mm M/41-D")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("100 x 81 mm (Estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Anti-Tank (Atk)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("50 x RB-55 (TOW BGM-71) ATGW")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("RB-56 Bill ATGW ATGW (on tracked vehicles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("500 x 84 mm Garl Gustav (Estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("500 x 84 mm M/86 (AT-4) (Estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Low Level Air Defence (LLAD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("16 x RBS-70 SAM (SP)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("100 x RBS-90 SAM (Towed and MANPAD) (Estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("30 x 40 mm Strv 90L")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Unmanned Air Vehicle")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Sperwer")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SWEDISH NAVY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Navy Strength")]), _vm._v(": approximately 2,500 available including about 500 coastal defence personnel.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Principal units:")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("4 x Submarines")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("5 x Corvettes")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("14 x Patrol Vessels")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Swedish Navy Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "58%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0283.jpg",
      "src": "images/e9781783032051_i0283.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("There are other port/base detachments at Musko, Berga, Goteborg, Visby, Malmo and Harnosand.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Surface Warfare Flotillas are structured for sea space monitoring and for the engagement of surface and underwater targets both in coastal areas and on the open sea. A mine clearance capability is preserved to ensure the security of ports and approaches.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The 1st Marine Regiment is capable monitoring inshore and coastal areas and can engage both surface and underwater targets.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Swedish Navy – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "44.94%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "55.06%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Submarines Tactical (SSK)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Gotland")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Sodermanland")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Corvettes (FS)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x Visby (first vessels entered service in 2009)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mine Countermeasures (MCM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Landsort")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x Koster")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Styrso")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Minelayers")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Patrol and Coastal Combatants (PCC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Stockholm")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x Tapper")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Miscellaneous")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("40 x Landing Craft (LCM/LCU)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("130 x Light Combat Boats/ Landing Craft")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("28 x Support vessels (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Coastal Defence")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("90 x RBS-17 (Hellfire) SSM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("50 x RBS-70 SAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("55 x 120 mm Mortars")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Some Piranha APC (Wheeled) reported")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SWEDISH AIR FORCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Air Force Strength")]), _vm._v(": Approximately 2,750 available")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Future plans")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("During the past decade the Swedish Defence Budget has been under extreme pressure and with a JAS-39 Grippen costing around Euros 56 million (US$75 million) many observers find it difficult to see how a force of around 100 x JAS-39 can be adequately supported.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("However in late 2008 the Swedish MoD announced that no further reductions in the Swedish Armed Forces would be made in the immediate future. If so it is likely that the Air Force will continue to keep around 100 x JAS-39 active (75 x JAS-39C and 25 x JAS-39D).")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Swedish Air Force Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "75%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0286.jpg",
      "src": "images/e9781783032051_i0286.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes: The Blekinge Wing (F-17) are mainly interceptors on constant standby: The Norbotten Wing (F21) is configured for intemational operations and includes a Base Battalion: The Helicopter Wing has detachments at - Boden (1 Sqn); Bergen (2 Sqn); Ronneby (3 Sqn); Gotenburg City Airport (S Sqn) and a detachment at Malmen.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Swedish Air Force – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "33.83%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "66.17%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighters (FTR)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("98 x JAS-39A Mulltirole Fighter")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("15 x JAS-39B Mulltirole Fighter/Trainer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("40 x JAS-39A Mulltirole Fighter/Trainer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x JAS-39D Mulltirole Fighter/Trainer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Electronic Intelligence (ELINT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x S-102B (Gulllfstream IV)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Airborne Early Warning (AEW)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x S-100B Argus")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport (Tpt)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x Tp-84 (Hercules C-130E)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Tp-100 (Saab 340)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Tp-100 VIP (Saab 340)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Training (Trg)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("62 x SK60 (Saab 105)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("14 x CH-46 Sea Knight (Hkp-4) Transport – being retired")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("16 x Bo 105 (Hkp-9) Utility")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9 x AS 332 Super Puma (Hkp-10) Support")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("20 x A 109 (Hkp-15) 8 x ship and 12 x land versions being delivered")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("18 x NH 90 (Hkp-14) on order – possibly 6 delivered by mid 2010 (13 x transport and 5 x ASW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Air launched missiles (ALM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("AIM-120B (RB-99) AAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("AMRAAM AAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("AIM-9L (RB-74) Sidewinder AAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Sky Flash (RB-71) AAM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("AGM-65 Maverick (RB-75) ASM")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("RB-15F ASM")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CURRENT UNIT DEPLOYMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("(over platoon strength – 30 personnel. These are approximate figures)")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "73.23%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "26.77%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (ISAF) Afghanistan")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 400")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (KFOR) Kosovo")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 250")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Chad/Central African Republic")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 85")])])])])])])]), _c('a', {
    attrs: {
      "id": "title91"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title91"
    }
  }), _c('a', {
    attrs: {
      "id": "title92"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("UNITED KINGDOM")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("BASIC FACTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "32.50%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "67.50%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("60.7 million")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Defence budget 2010:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 44 billion (UK£37 billion) (US$54 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GDP:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Euros 1,680 billion (UK£1,400 billion) (US$2,100 billion)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Land area:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("242,277 sq kms (94,500 sq miles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Capital:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("London (population 7.5 million)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Life expectancy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("79 years")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Population growth rate:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("0.42 per cent")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Total Armed Forces")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "32.93%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "67.07%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Army:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("108,800 (including personnel in training)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Royal Navy:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("38,700 (including personnel in training)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Royal Air Force:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4,000 (including personnel in training)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Volunteer Reserves:")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("29,000 (probably 19,000 immediately available)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Royal Naval figure includes some 7,500 Royal Marines.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MINISTRY OF DEFENCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contact Details")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Ministry of Defence")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Whitehall")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("London, SW1A 2HB")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("United Kingdom")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Tel"), _c('strong', {
    staticClass: "b"
  }, [_vm._v(":")]), _vm._v(" +44 207 218 9000")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Fax: +44 207 218 6360")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("UK ARMY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army Strength")]), _vm._v(": 108,800 (including personnel in training)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Formations")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Corps Headquarters (ARRC)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Divisional HQ in Germany")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Divisional HQ in UK")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("5 x Non-deployable divisional type HQ in UK")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("8 x Deployable Brigade HQ (excluding 3 Commando Brigade)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("10 x Regional Brigade HQ")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Northern Ireland Brigade HQ")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Major Units:")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("10 x Armoured Regiments")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("36 x Infantry Battalions")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("15 x Artillery Regiments (Battalion size)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("11 x Engineer Regiments")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("12 x Signal Regiments")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("7 x Equipment Support Battalions")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("17 x Logistic Regiments")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("8 x Medical Regiments")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Note:")]), _vm._v(" Two of the Infantry Battalion are Gurkha battalions (Royal Gurkha Rifles). There are approximately 3,600 Gurkhas in the British Army who man the 2 x Gurkha Infantry Battalions (Royal Gurkha Rifles) and a number of other support units.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chain of Command")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Army is controlled from the MoD via the following subsidiary headquarters and a number of smaller headquarters worldwide. The diagram illustrates this chain of command as at mid 2009.")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "62%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0292.jpg",
      "src": "images/e9781783032051_i0292.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note: From Mid 2009 HQ Land Forces has been located at Andover in Hampshire having moved from Wilton near Salisbury.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Permanent Joint Headquarters (PJHQ) at Northwood in Middlesex has an important input into command at the operational level and it is almost certain that any operation with which the army is involved will be under the overall command of PJHQ.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Field Army Structure:")]), _vm._v(" Major units under the direct command of the Field Army include:\n")])]), _vm._v(" "), _c('ul', {
    staticClass: "bl"
  }, [_c('li', {
    staticClass: "bsl"
  }, [_vm._v("1st Division (Herford – Germany)")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("3rd Division (Bulford – UK)")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("6th Division (York)")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Combat Service Support Group (United Kingdom)")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Combat Service Support Group (Germany)")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Land Warfare Centre")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Note:")]), _vm._v(" HQ 6th Division was formed in August 2008 as the third deployable divisional headquarters.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Regional Forces Structure:")]), _vm._v(" Major units that assist Commander Regional Forces are amongst the following:")])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "34.12%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "65.88%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("♦ 2 Division")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("(Regenerative Division)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("♦ 4 Division")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("(Regenerative Division)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("♦ 5 Division")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("(Regenerative Division)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("♦ United Kingdom Support Command (Germany)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("♦ London District")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("♦ Army Recruiting & Training Division")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Joint Helicopter Command:")]), _vm._v(" With about 350 aircraft as follows:\n")])]), _vm._v(" "), _c('ul', {
    staticClass: "bl"
  }, [_c('li', {
    staticClass: "bsl"
  }, [_vm._v("4 x Royal Naval Helicopter Squadrons (113 aircraft)")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("6 x Army Aviation Regiments – including 1 x Reserve (151 aircraft)")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("7 x Royal Air Force Helicopter Squadrons – including 1 x RAuxAF Helicopter Support Squadron – 86 aircraft)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("UK Brigades")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The UK currently has the following combat brigades available for operations:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Armoured Brigades:")]), _vm._v(" 7 Armoured Brigade; 20 Armoured Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Mechanised Brigades:")]), _vm._v(" 1 Mechanised Brigade; 4 Mechanised Brigade; 12 Mechanised Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Light Brigades:")]), _vm._v(" 16 Air Assault Brigade; 19 Light Brigade; 52 Infantry Brigade; 11 Light Brigade HQ (for operations in Afghanistan); 3 Commando Brigade (Royal Marines);")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("UK Army – 16 Air Assault Brigade")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The following diagram shows a possible configuration for 16 Air Assault Brigade during significant operations:")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "67%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0294.jpg",
      "src": "images/e9781783032051_i0294.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This brigade is under the command of the JHC (Joint Helicopter Command) and would be detached to other formations for operations.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Support helicopters are provided by the RAF (from the Joint Helicopter Command) and the Brigade would normally expect to operate with 18 x Chinook and 18 x Puma. An air assault infantry battalion can be moved by 20 x Chinook equivalents lifts. Each air assault infantry battalion has a personnel strength of 687 and a battalion has 12 x ATGW firing posts.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("UK Army – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "36.83%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "63.17%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Main Battle Tanks (MBT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("345 x Challenger 2")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Reconnaissance (Recce)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("320 x Scimitar (tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("11 x Fuchs NBC Recce (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("200 x Panther (wheeled – 200 more on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Armoured Infantry Fighting Vehicles (AIFV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("550 x MCV 80 Warrior (tracked – 200 more in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Armoured Personnel Carrier (APC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("380 x Bulldog (tracked – FV 432 type)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("700 x AFV 432 Trojan (tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("495 x Spartan (tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("147 x Saxon Patrol (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("250 x Mastiff (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("130 x Jackal (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("166 x Vector (wheeled)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Self Propelled Artillery (SP Arty)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("134 x AS 90 SP (40 more in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Towed Artillery (Towed)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("135 x 105mm Light Gun")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Multiple Rocket Launcher (MRL)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("42 x 227mm (G)MLRS")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Mortars (Mor)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("600 x 60mm Light Mortar (possibly 1,500 in store)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("470 x 81mm Mortar (including 112 SP)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Anti-Tank (Atk)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("300 x Javelin ATGW")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("1,000 x MBT LAW (estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Low Level Air Defence (LLAD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("84 x Stormer with HVM (tracked)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("24 x SP Rapier Fire Units")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("145 x Starstreak LML")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Army Aviation")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("66 x Apache AH Mk 1 (attack)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("100 x Lynx (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("42 x Gazelle (utility)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Unmanned Air Vehicles (UAV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("54 x Watchkeeper (deliveries commenced)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("100 plus x Hermes 450 (our estimate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Desert Hawk")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ROYAL NAVY")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Navy strength:")]), _vm._v(" Royal Navy: approximately 38,700 (including personnel in training)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Principal units:")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("4 x Nuclear Powered Ballistic Missile Firing Submarines")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("8 x Nuclear Powered Attack Type Submarines")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Aircraft Carriers")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Helicopter Carrier")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Amphibious Assault Ships")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("24 x Destroyers and Frigates")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("16 x Minehunters and minesweepers")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("5 x Ocean survey vessels")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Antarctic patrol ship; 20 x Patrol vessels")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Royal Marines Summary")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Commando Brigade Headquarters (HQ 3 Cdo Bde) with:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("3 x Royal Marine Commando (Battalion Size)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Infantry Battalion (1 Bn The Rifles)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Commando Regiment Royal Artillery")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Commando Squadron Royal Engineers")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Commando Logistic Regiment")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 Commando Assault Group (Landing-Craft)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Royal Navy Outline Organisation")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "71%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0297.jpg",
      "src": "images/e9781783032051_i0297.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Royal Navy – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "38.86%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "61.14%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Strategic (SSBN)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Trident Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Submarines Tactical (SSK)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x Trafalgar Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Swiftsure Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Astute Class (2 more under construction)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Aircraft Carriers (CV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Invincible Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Destroyers (DD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x Type 42")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Type 45 ( 4 more under construction)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Frigates (FF)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("13 x Type 23")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Type 22")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Assault Vessels (LPD)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Albion; 1 x Bulwark")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Ocean (Helicopter Carrier)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mine Countermeasures (MCM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x Hunt Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8 x Sandown Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Patrol and Coastal Combatants (PCC)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x River Class")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Scimitar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("16 x Archer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Hydrographic")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Ice Patrol (Antartic)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Support (Royal Fleet Auxiliary)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Fast Fleet Tankers")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Small Fleet Tankers")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2 x Support Tankers")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Replenishment Ships")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Aviation Training Ship")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4 x Landing Ships")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1 x Forward Repair Ship")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Naval Aviation")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("42 x Merlin MK 1 Helicopters (ASW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("(FAF – Forward Available Fleet)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10 x Sea King Mk 7 (AEW)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("70 x Lynx Mk 3/Mk 8 – (ASW and missile armed for surface")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("ship attack")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6 x Lynx Mk 7 (with ATGW for Royal Marines)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x Hawk. Fixed wing trainer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12 x Jetstream. Fixed wing trainer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("37 x Sea King HC Mk4 (with the Joint Helicopter Command – JHC)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ROYAL AIR FORCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Royal Air Force Strength:")]), _vm._v(" 44,000 (including personnel in training).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Royal Air Force Squadrons")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "70.87%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "29.13%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Strike/Attack Squadrons")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Offensive Support Squadrons")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Reconnaissance Squadrons")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Air Defence (Interceptor) Squadrons")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Maritime Patrol Squadrons")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Airborne Early Warning Squadrons")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport/Tanker Squadrons")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Helicopter Squadrons (2 SAR)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Ground Defence Squadrons")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Royal Air Force Outline Organisation")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("HQ Air Command is located at RAF High Wycombe in Buckinghamshire. The Command was formed in April 2007 following the merger of RAF Strike Command and RAF Personnel and Training Command. HQ Air Command works with the MoD and PJHQ (Permanent Joint Headquarters) to provide the correct mix of airpower to various operational areas.")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0300.jpg",
      "src": "images/e9781783032051_i0300.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes: (1) C-in-C - Commander-in-Chief; (2) DE&S - Defence Equipment and Support; (3) AOC - Air Officer Commanding; COS - Chief of Staff; (4) DGCS relates to a modular system of mobile, deployable and fixed assets that are designed to task, receive, process, exploit all source intelligence from national and alliance collection assets; (5) DLS - Director Legal Services; Groups are normally commanded by Air Vice Marshals.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Royal Air Force Regiment is responsible for airbase security and provides Rapier air defence within a composite RAF/Army unit.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Royal Air Force – Equipment")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "47.70%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "52.30%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighters (FTR)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("28 x Typhoon F2/T1/T1A")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("64 x Tornado F3 (being withdrawn)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Multi- Role")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("28 x Typhoon FGR4")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Note : The UK RAF has orders for 160 x Typhoon aircraft confirmed.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fighter Ground Attack (FGA)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("112 x Tornado GR4/4A")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Reconnaissance (Recce)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5 x Sentinel")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("24 x Tornado GR4A")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Airborne Early Warning (AEW)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("7 x E-3D Sentry")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Maritime Reconnaissance (MR)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9 x Nimrod MRA4 (from 2012)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Electronic Warfare (ELINT)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3 x Nimrod R1")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transport/Tanker (Tpt/Tkr)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9 x Tristar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("15 x VC-10")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("14 x Hercules K")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("24 x Hercules J")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("6 x C-17")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("2 x BAe 146")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("6 x BAe 125")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("2 x BN-2 Islander")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Training (Trg)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("10 x Hawk 128 (total of 28 on order)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("100 x Hawk T")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("100 x Grob Tutor")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("35 x Firefly")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("90 x Tucano")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("9 x Dominie")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("30 x AS-355 Squirrel (hel)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("12 x Bell 412 (hel)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Helicopters (Hel)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("40 x CH-47 Chinook")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("28 x Merlin")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("37 x SA-330 Puma")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("24 x HAR-3A Sea King")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("4 x Bell 412")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Air launched missiles (ALM)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("AIM-9 Sidewinder (AAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("AMRAAM (AAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("ASRAAM (AAM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("ALARM (ARM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Brimstone (ASM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("AGM-65 Maverick (ASM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Storm Shadow (ASM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Harpoon (ASSM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Stingray (ASSM)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Unmanned Air Vehicles (UAV)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("3 x Reaper (more on order)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Joint Forces")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The UK MoD has created the following Joint Force Organisations which operate in support of all three Armed Services.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Joint Force Harrier:")]), _vm._v(" 2 x Royal Navy Squadrons; 2 x Royal Air Force Squadrons (being stood down).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Joint Helicopter Command:")]), _vm._v(" 4 x Royal Naval Helicopter Squadrons; 6 x Army Aviation Regiments (including 1 x Volunteer Reserve); 7 x Royal Air Force Helicopter Squadrons (including 1 x RAuxAF Helicopter Support Squadron).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Joint Special Forces Group:")]), _vm._v(" 1 x Regular Special Air Service (SAS) Regiment; 2 x Volunteer Reserve Special Air Service Regiments; 4 x Special Boat Service (SBS) Squadrons; 1 x Special Reconnaissance Regiment; 1 x Special Forces Support Group.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Joint Nuclear, Biological and Chemical Regiment:")]), _vm._v(" Consists of squadrons with a NBC defence capability.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CURRENT MAJOR UNIT DEPLOYMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("(over platoon strength – 30 personnel. These are approximate figures)")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "42.35%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "57.65%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NATO (ISAF) Afghanistan")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 10,000 approximate")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Falkland Islands")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 2,000 approximate")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Cyprus")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 1,700")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Brunei")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 550")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Germany")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 21,000 approximate")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Gibraltar")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("- 280 (including Gibraltar Regiment)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Royal Navy participates in a complete range of both NATO and EU maritime deployments.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NATO Headquarters")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The following NATO headquarters are situated in the UK:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Joint Force Componnent Command Maritime – Northwood")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("HQ Allied Rapid Reaction Corps – Innsworth")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("UK Strategic Defence and Security Review (SDSR) 2010")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The following are the most significant elements of the UK SDSR which were announced in late 2010.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("UK Army:")]), _vm._v(" Land force capabilities will be based around six brigades. Five of these would be multi-role brigades each consisting of around 6,500 personnel that are comprised of main battle tanks, armoured reconnaissance units, armoured, mechanised and light infantry elements, plus artillery, engineers, army aviation and a complete range of support units. One brigade would always be part of the High Readiness Force and where necessary these brigades could be self supporting. 16 Air Assault Brigade would be the sixth brigade.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("All of the above could form part of a much larger organisation (possibly divisional size) under the command of a deployable UK divisional headquarters. For multinational operations the headquarters of the Allied Rapid Reaction Corps (HQ ARRC) would be available.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Challenger main battle tank numbers will reduce by about 40% and heavy artillery numbers such as the 155 mm AS90 will reduce by about 35%. It is likely that Army units will have been withdrawn from their bases in Germany by 2020.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Royal Air Force:")]), _vm._v(" In the future the Royal Air Force will continue to provide the air defence of the United Kingdom and territories in the South Atlantic. To meet this requirement, in the longer term, a fast jet force of both Eurofighter Typhoon and Joint Strike Fighter aircraft will provide air defence, precision ground attack and combat ISTAR capabilities. In the short term elements of the Tornado fleet will be retained.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Royal Air Force will also provide a fleet of strategic and tactical airlift aircraft based around 7 x C-17, 22 x A400M and 14 x Airbus A330 tanker and transport aircraft. The Chinook helicopter fleet will be increased by 12 new aircraft and Merlin helicopters will be retained. ISTAR capabilities will be enhanced and the UK may purchase 3 x KC-135 Joint Rivet signals intelligence aircraft to improve the existing ISTAR capability. It is likely that the Royal Air Force will become the lead agency in the proposed UK Cyber Operations Group.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Royal Navy:")]), _vm._v(" Under the terms of the Future Force 2020 proposals the Royal Navy will provide a continuous nuclear deterrent system at sea, maritime defence of the United Kingdom and defence of territories in the South Atlantic. Other retained forces will include:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Seven Astute class nuclear powered hunter killer submarines equipped with Tomahawk land attack cruise missiles . Astute class submarines are capable of operating at sea indefinitely.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Two new aircraft carriers, one of which will be kept at extended readiness. The aircraft carrier at sea will be equipped with Joint Strike Fighters and a range of helicopters that (depending on the operational requirement) could include Apache attack helicopters and possibly Chinook and Merlin support helicopters. It is expected that following the fitting of catapult and arrestor systems the first of these new carriers will be in-service from about 2020.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("A balanced surface fleet of 19 frigates and destroyers would be retained.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Royal Marine’s 3 Commando Brigade will continue to provide an important maritime response capability to the High Readiness Force. 3 Commando Brigade will be able to land significant forces anywhere in the world.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Joint Forces:")]), _vm._v(" The Joint Force Harrier will be stood down.")])])])])]), _c('a', {
    attrs: {
      "id": "title92"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf7d1664","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781783032051_c02.vue
// module id = 72
// module chunks = 0